import { API_URL } from "../../api/api";

export const REMEMBER_ME = "remember-me";
export const USER_ROLE = "role";
export const ID = "id";
export const PALIKA_ID = "palikaId";
export const CARD_VALIDATION_URL = `${window.location.origin}/card-validation`;
export const PUBLIC_REPRESENTATIVE_CARD_VALIDATION_URL = `${window.location.origin}/public-representative-card-validation`;

export const OTHER = "OTHER";
export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_OFFICE_ADMIN = "ROLE_OFFICE_ADMIN";
export const ROLE_OFFICE_STAFF = "ROLE_OFFICE_STAFF";
export const ROLE_STAFF = "ROLE_STAFF";
export const LEFT_SIDEBAR_WIDTH = 260;
export const APP_BAR_HEIGHT = 64;
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const SUCCESS = "success";
export const ERROR = "error";
export const USER_INFO = "USER_INFO";
export const AFTER_DELETE_YOU_CAN_NOT_UNDONE_MSG = "एक पटक हटाइसकेपछि, यो स्थायी रूपमै प्रणालीबाट हटाइनेछ र तपाईं यस कार्यलाई पूर्ववत गर्न सक्नुहुन्न।";
export const BHEEMDATTA_PIS = "/bheemdatta";
export const KAILARI_PIS = "/kailari";
export const API_WITHOUT_LOADER = [`${API_URL.staff}`, `${API_URL.publicRepresentative}`];

export const DEFAULT_ROW_SIZE = 50;
export const SEARCH_TIME_OUT = 1200;
// Common Messages
export const SERVICE_NA = "Some of our services are currently not available. Please try again later.";
export const SOMETHING_WENT_WRONG = "Oops! Something went wrong. Please try again.";
export const REQUIRED_FIELD = "This is a required field.";
export const ENTER_VALID_EMAIL = "कृपया मान्य ईमेल ठेगाना प्रविष्ट गर्नुहोस्।";
export const NO_RECORDS_FOUND = "माफ गर्नुहोस्, कुनै रेकर्ड फेला परेन।";
export const PASSWORD_DO_NOT_MATCHES = "नयाँ पासवर्ड र कन्फर्म पासवर्ड मेल खाएन।";
export const SESSION_EXPIRED = "तपाईंको सेसन समाप्त भएको छ, कृपया लग-इन गर्नुहोस।";
export const IS_SESSION_EXPIRED = "isSessionExpired";
export const EDIT_SELECTED_RECORD = "चयनित रेकर्ड सम्पादन गर्नुहोस्।";
export const LEAVE_EXCEED = "कृपया जम्मा भन्दा थोरै वा बराबर संख्या प्रदान गर्नुहोस्। ";
export const GREATER_THAN_ONE = "कृपया 0 भन्दा ठूलो संख्या प्रदान गर्नुहोस्।";
export const FILE_SIZE_EXCEED = "तपाईंले छनौट गर्नुभएको फाईलको साइज धेरै ठूलो छ, कृपया सानो फाईल (१० एम.बी भन्दा कम) संलग्न गर्नुहोस्।";
export const ALL_FILES_SIZE_EXCEED = "तपाईंले छनौट गर्नुभएको फाईलहरुको साइज धेरै ठूलो छ, कृपया सबै फाइल गरेर (३० एम.बी भन्दा कम) संलग्न गर्नुहोस्।";
export const PHONE_NUMBER_MUST_NOT_BE_GREATER_THAN_TEN = "Max 10 characters allowed in Phone No.";
export const PALIKA_TYPES = [
  { value: "MAHANAGAR_PALIKA", label: "महानगरपालिका" },
  { value: "UPAMAHANAGAR_PALIKA", label: "उप-महानगरपालिका" },
  { value: "NAGAR_PALIKA", label: "नगरपालिका" },
  { value: "GAUN_PALIKA", label: "गाउँपालिका" }
];

export const USER_ROLES = [
  { value: ROLE_ADMIN, label: "प्रणाली प्रमुख (Super Admin)" },
  { value: ROLE_OFFICE_ADMIN, label: "PIS प्रशासक" },
  { value: ROLE_OFFICE_STAFF, label: "कार्यालय कर्मचारी" },
  { value: ROLE_STAFF, label: "कर्मचारी" }
];

export const ADD_USER_ALLOWED_ROLES_FOR_ADMIN = [
  { value: ROLE_OFFICE_ADMIN, label: "PIS प्रशासक" },
];

export const ADD_USER_ALLOWED_ROLES_FOR_OFFICE_ADMIN = [
  { value: ROLE_OFFICE_ADMIN, label: "PIS प्रशासक" },
];

export const GENDER_OPTIONS = [
  { value: "MALE", label: "पुरुष" },
  { value: "FEMALE", label: "महिला" },
  { value: "OTHER", label: "अन्य" }
];

export const CASTE_CODES = [
  { value: "1", label: "दलित (१)" },
  { value: "2", label: "जनजाती (२)" },
  { value: "3", label: "मधेशी (३)" },
  { value: "4", label: "मुस्लिम (४)" },
  { value: "5", label: "ब्राह्मण/क्षेत्री (५)" },
  { value: "6", label: "अन्य (६)" }
];

export const ROW_SIZE = [
  { value: 50, label: "50" },
  { value: 100, label: "100" },
  { value: 250, label: "250" },
  { value: 500, label: "500" }
]

export const RETIREMENT_CONDITION_TYPE = [
  { value: "MANDATORY", label: "अनिवार्य" },
  { value: "VOLUNTARY", label: "स्वेच्छिक" },
  { value: "RESIGNATION", label: "राजिनामा" }
]

export const EDUCATION_DETAILS = [
  {
    educationalQualificationOrDegree: "",
    studySubjectOrFaculty: "",
    yearPassed: "",
    recievedGradingCategory: "",
    educationalInstitutionNameAndCountry: ""
  },
  {
    educationalQualificationOrDegree: "",
    studySubjectOrFaculty: "",
    yearPassed: "",
    recievedGradingCategory: "",
    educationalInstitutionNameAndCountry: ""
  },
  {
    educationalQualificationOrDegree: "",
    studySubjectOrFaculty: "",
    yearPassed: "",
    recievedGradingCategory: "",
    educationalInstitutionNameAndCountry: ""
  },
  {
    educationalQualificationOrDegree: "",
    studySubjectOrFaculty: "",
    yearPassed: "",
    recievedGradingCategory: "",
    educationalInstitutionNameAndCountry: ""
  },
  {
    educationalQualificationOrDegree: "",
    studySubjectOrFaculty: "",
    yearPassed: "",
    recievedGradingCategory: "",
    educationalInstitutionNameAndCountry: ""
  }
];

export const AWARD_AND_TESTIMONIAL_DETAILS = [
  {
    awardOrTestimonialDescription: "",
    dateReceived: "",
    reasonToRecieve: "",
    convenience: ""
  },
  {
    awardOrTestimonialDescription: "",
    dateReceived: "",
    reasonToRecieve: "",
    convenience: ""
  },
  {
    awardOrTestimonialDescription: "",
    dateReceived: "",
    reasonToRecieve: "",
    convenience: ""
  },
  {
    awardOrTestimonialDescription: "",
    dateReceived: "",
    reasonToRecieve: "",
    convenience: ""
  },
];

export const MEDICAL_EXPENSES_DETAILS = [
  {
    expensesType: "",
    amountTakenDate: "",
    amountTaken: "",
    verifiedBy: "",
    documents: [],
    remark: ""
  },
  {
    expensesType: "",
    amountTakenDate: "",
    amountTaken: "",
    verifiedBy: "",
    documents: [],
    remark: ""
  },
  {
    expensesType: "",
    amountTakenDate: "",
    amountTaken: "",
    verifiedBy: "",
    documents: [],
    remark: ""
  },
  {
    expensesType: "",
    amountTakenDate: "",
    amountTaken: "",
    verifiedBy: "",
    documents: [],
    remark: ""
  },
  {
    expensesType: "",
    amountTakenDate: "",
    amountTaken: "",
    verifiedBy: "",
    documents: [],
    remark: ""
  }
];

export const DEPARTMENTAL_PUNISHMENT_DETAILS = [
  {
    punishmentType: "",
    punishmentAnnouncedDate: "",
    post: "",
    label: "",
    serviceGroup: "",
    office: "",
    sentenceReleaseDate: "",
    documents: []
  },
  {
    punishmentType: "",
    punishmentAnnouncedDate: "",
    post: "",
    label: "",
    serviceGroup: "",
    office: "",
    sentenceReleaseDate: "",
    documents: []
  },
  {
    punishmentType: "",
    punishmentAnnouncedDate: "",
    post: "",
    label: "",
    serviceGroup: "",
    office: "",
    sentenceReleaseDate: "",
    documents: []
  },
];

export const PREGNANCY_CARE_LEAVE_INFO = [
  {
    leaveStartDate: "",
    leaveEndDate: "",
    totalLeaveTaken: "",
    verifiedBy: "",
    documents: [],
    remark: ""
  },
  {
    leaveStartDate: "",
    leaveEndDate: "",
    totalLeaveTaken: "",
    verifiedBy: "",
    documents: [],
    remark: ""
  },
  {
    leaveStartDate: "",
    leaveEndDate: "",
    totalLeaveTaken: "",
    verifiedBy: "",
    documents: [],
    remark: ""
  }
];

export const LEAVE_TYPES = [
  { value: "IMMEDIATE_LEAVE", label: "भैपरी आउने बिदा" },
  { value: "FESTIVAL_LEAVE", label: " चाडपर्व बिदा" },
  { value: "HOME_LEAVE", label: "घर विदा" },
  { value: "SICK_LEAVE", label: "बिरामी बिदा" },
  { value: "PREGNANCY_LEAVE", label: "प्रसूति बिदा" },
  { value: "UNPAID_PREGNANCY_LEAVE", label: " बेतलबी प्रसूति बिदा" },
  { value: "PREGNANCY_CARE_LEAVE", label: "प्रसूती स्याहार बिदा " },
  { value: "DEATH_RITUAL_LEAVE", label: "किरिया बिदा" },
  { value: "STUDY_LEAVE", label: "अध्ययन बिदा" },
  { value: "COMMON_ABNORMAL_LEAVE", label: "सामान्य असाधरण बिदा" },
  { value: "STUDY_ABNORMAL_LEAVE", label: "अध्ययन असाधरण बिदा" },
  { value: "INSTEAD_LEAVE", label: "सट्टा बिदा" },
  { value: "ADDITIONAL_SERVICE_LEAVE", label: "अतिरिक्त सेवा बिदा" },
  { value: "SERVING_INTERNATIONAL_ORGANIZATION_LEAVE", label: "अन्तराष्ट्रिय संघ संस्थामा सेवा गर्न दिईने बिदा" },
  { value: "ADDITIONAL_SERVICE_LEAVE", label: "अतिरिक्त सेवा बिदा" },
]

export const EXPENSES_TYPE = [
  { value: "INDIVIDUAL", label: "स्वयं" },
  { value: "FAMILY", label: "परिवार" }
]

export const PUNISHMENT_TYPES = [
  { value: "SUSPENSION", label: "निलम्बन" },
  { value: "SALARY_WITHHOLDING", label: "तलब रोक्का" },
  { value: "PROMOTION_WITHHOLDING", label: "बढुवा रोक्का" }
]

export const TRANSFER_PROMOTION_TYPE = [
  { value: "transfer", label: "सरुवा" },
  { value: "promotion", label: "बढुवा" },
]

export const OPERATION_LIST_BEFORE_DEPLOYMENT = [
  {
    value: "SET_POST_NAME_IN_STAFF_DETAILS", label: "SET POST NAME IN STAFF DETAILS"
  }
]

export const PROVINCE_DISTRICT_PALIKA_LIST = [
  {
    value: "PROVINCE_1", label: "कोशी प्रदेश", englishLabel: "Koshi Province", districts: [
      {
        value: "taplejung", label: "ताप्लेजुंग", englishLabel: "Taplejung", palikas: [
          { value: "TAPLEJUNG_FUNGLING_MUN", label: "फुङलिङ नगरपालिका", englishLabel: "Fungling Municipality" },
          { value: "TAPLEJUNG_AATHRAI_TRIBENI_MUN", label: "आठराई त्रिवेणी गाउँपालिका", englishLabel: "Aathrai Tribeni Rural Municipality" },
          { value: "TAPLEJUNG_SIDINGWA_MUN", label: "सिदिङ्वा गाउँपालिका", englishLabel: "Sidingwa Rural Municipality" },
          { value: "TAPLEJUNG_FAKTANGLUNG_MUN", label: "फक्ताङलुङ गाउँपालिका", englishLabel: "Faktanglung Rural Municipality" },
          { value: "TAPLEJUNG__MUKWAKHOLA_MUN", label: "मिक्वाखोला गाउँपालिका", englishLabel: " Mukwakhola Rural Municipality" },
          { value: "TAPLEJUNG_MERINGDEN_MUN", label: "मेरिङदेन गाउँपालिका", englishLabel: "Meringden Rural Municipality" },
          { value: "TAPLEJUNG_MAUWAKHOLA_MUN", label: "मैवाखोला गाउँपालिका", englishLabel: "Mauwakhola Rural Municipality" },
          { value: "TAPLEJUNG_PATHIBHARA_YANGWARAK_MUN", label: "पाथीभरा याङवरक गाउँपालिका", englishLabel: "Pathibhara Yangwarak Rural Municipality" },
          { value: "TAPLEJUNG_SIRIJANGHA_MUN", label: "सिरीजङ्घा गाउँपालिका", englishLabel: "Sirijangha Rural Municipality" }
        ]
      },
      {
        value: "pachthar", label: "पाँचथर", englishLabel: "Panchthar", palikas: [
          { value: "PACHTHAR_FIDIM_MUN", label: "फिदिम नगरपालिका", englishLabel: "Fidim Municipality" },
          { value: "PACHTHAR_FALELUNG_MUN", label: "फालेलुङ गाउँपालिका", englishLabel: "Falelung Rural Municipality" },
          { value: "PACHTHAR_FALGUNANDA_MUN", label: "फाल्गुनन्द गाउँपालिका", englishLabel: "Falgunanda Rural Municipality" },
          { value: "PACHTHAR_HILIHANG_MUN", label: "हिलिहाङ गाउँपालिका", englishLabel: "Hilihang Rural Municipality" },
          { value: "PACHTHAR_KAMMAYAK_MUN", label: "कुम्मायक गाउँपालिका", englishLabel: "Kammayak Rural Municipality" },
          { value: "PACHTHAR_MIKLAJUNG_MUN", label: "मिक्लाजुङ गाउँपालिका", englishLabel: "Miklajung Rural Municipality" },
          { value: "PACHTHAR_TUMBEWA_MUN", label: "तुम्बेवा गाउँपालिका", englishLabel: "Tumbewa Rural Municipality" },
          { value: "PACHTHAR_YANGWARAK_MUN", label: "याङवरक गाउँपालिका", englishLabel: "Yangwarak Rural Municipality" }
        ]
      },
      {
        value: "illam", label: "इलाम", englishLabel: "Ilam", palikas: [
          { value: "ILLAM_ILLAM_MUN", label: "ईलाम नगरपालिका", englishLabel: "Illam Municipality" },
          { value: "ILLAM_DEUMAI_MUN", label: "देउमाई नगरपालिका", englishLabel: "Deumai Municipality" },
          { value: "ILLAM_MAI_MUN", label: "माई नगरपालिका", englishLabel: "Mai Municipality" },
          { value: "ILLAM_SURYODAYA_MUN", label: "सूर्योदय नगरपालिका", englishLabel: "Suryodaya Municipality" },
          { value: "ILLAM_FAKFOKTHUM_MUN", label: "फाकफोकथुम गाउँपालिका", englishLabel: "Fakfokthum Rural Municipality" },
          { value: "ILLAM_CHULACHALI_MUN", label: "चुलाचुली गाउँपालिका", englishLabel: "Chulachali Rural Municipality" },
          { value: "ILLAM_MAIJOGMAI_MUN", label: "माईजोगमाई गाउँपालिका", englishLabel: "Maijogmai Rural Municipality" },
          { value: "ILLAM_MANGSEBUNG_MUN", label: "माङसेबुङ गाउँपालिका", englishLabel: "Mangsebung Rural Municipality" },
          { value: "ILLAM_RONG_MUN", label: "रोङ गाउँपालिका", englishLabel: "Rong Rural Municipality" },
          { value: "ILLAM_SANDAKPUR_MUN", label: "सन्दकपुर गाउँपालिका", englishLabel: "Sandakpur Rural Municipality" }
        ]
      },
      {
        value: "jhapa", label: "झापा", englishLabel: "Jhapa", palikas: [
          { value: "JHAPA_MECHINAGAR_MUN", label: "मेचीनगर नगरपालिका", englishLabel: "Mechinagar Municipality" },
          { value: "JHAPA_DAMAK_MUN", label: "दमक नगरपालिका", englishLabel: "Damak Municipality" },
          { value: "JHAPA_KANKAI_MUN", label: "कन्काई नगरपालिका", englishLabel: "Kankai Municipality" },
          { value: "JHAPA_BHADRAPUR_MUN", label: "भद्रपुर नगरपालिका", englishLabel: "Bhadrapur Municipality" },
          { value: "JHAPA_ARJUNDHARA_MUN", label: "अर्जुनधारा नगरपालिका", englishLabel: "Arjundhara Municipality" },
          { value: "JHAPA_SHIWASHATAAKSHI_MUN", label: "शिवशताक्षी नगरपालिका", englishLabel: "Shiwashataakshi Municipality" },
          { value: "JHAPA_GAURADAHA_MUN", label: "गौरादह नगरपालिका", englishLabel: "Gauradaha Municipality" },
          { value: "JHAPA_BIRTAMOD_MUN", label: "विर्तामोड नगरपालिका", englishLabel: "Birtamod Municipality" },
          { value: "JHAPA_KAMAL_MUN", label: "कमल गाउँपालिका", englishLabel: "Kamal Rural Municipality" },
          { value: "JHAPA_GAURIGANJA_MUN", label: "गौरीगंज गाउँपालिका", englishLabel: "Gauriganja Rural Municipality" },
          { value: "JHAPA_BAHRADASHI_MUN", label: "बाह्रदशी गाउँपालिका", englishLabel: "Bahradashi Rural Municipality" },
          { value: "JHAPA_JHAPA_MUN", label: "झापा गाउँपालिका", englishLabel: "Jhapa Rural Municipality" },
          { value: "JHAPA_BUDDHASHANTI_MUN", label: "बुद्धशान्ति गाउँपालिका", englishLabel: "Buddhashanti Rural Municipality" },
          { value: "JHAPA_HALDIWARI_MUN", label: "हल्दिवारी गाउँपालिका", englishLabel: "Haldiwari Rural Municipality" },
          { value: "JHAPA_KACHANKAWAL_MUN", label: "कचनकवल गाउँपालिका", englishLabel: "Kachankawal Rural Municipality" }
        ]
      },
      {
        value: "morang", label: "मोरङ", englishLabel: "Morang", palikas: [
          { value: "MORANG_WIRATANAGAR_MUN", label: "विराटनगर महानगरपालिका", englishLabel: "Wiratanagar Metropolitan City" },
          { value: "MORANG_BELWARI_MUN", label: "बेलवारी नगरपालिका", englishLabel: "Belwari Municipality" },
          { value: "MORANG_LETANG_MUN", label: "लेटाङ नगरपालिका", englishLabel: "Letang Municipality" },
          { value: "MORANG_PATHARI_SANISHRARE_MUN", label: "पथरी शनिश्चरे नगरपालिका", englishLabel: "Pathari Sanishrare Municipality" },
          { value: "MORANG_RANGELI_MUN", label: "रंगेली नगरपालिका", englishLabel: "Rangeli Municipality" },
          { value: "MORANG_RATUWAMAI_MUN", label: "रतुवामाई नगरपालिका", englishLabel: "Ratuwamai Municipality" },
          { value: "MORANG_SUNBARSI_MUN", label: "सुनवर्षि नगरपालिका", englishLabel: "Sunbarsi Municipality" },
          { value: "MORANG_URLAWARI_MUN", label: "उर्लावारी नगरपालिका", englishLabel: "Urlawari Municipality" },
          { value: "MORANG_SUNDARAHARAICHA_MUN", label: "सुन्दरहरैचा नगरपालिका", englishLabel: "Sundaraharaicha Municipality" },
          { value: "MORANG_BUDIGANGA_MUN", label: "बुढीगंगा गाउँपालिका", englishLabel: "Budiganga Rural Municipality" },
          { value: "MORANG_DHANPAALATHAAN_MUN", label: "धनपालथान गाउँपालिका", englishLabel: "Dhanpaalathaan Rural Municipality" },
          { value: "MORANG_GRAMTHAN_MUN", label: "ग्रामथान गाउँपालिका", englishLabel: "Gramthan Rural Municipality" },
          { value: "MORANG_JAHADA_MUN", label: "जहदा गाउँपालिका", englishLabel: "Jahada Rural Municipality" },
          { value: "MORANG_KANEPOKHARI_MUN", label: "कानेपोखरी गाउँपालिका", englishLabel: "Kanepokhari Rural Municipality" },
          { value: "MORANG_KATAHARI_MUN", label: "कटहरी गाउँपालिका", englishLabel: "Katahari Rural Municipality" },
          { value: "MORANG_KERAWARI_MUN", label: "केरावारी गाउँपालिका", englishLabel: "Kerawari Rural Municipality" },
          { value: "MORANG_MIKLAJUNG_MUN", label: "मिक्लाजुङ गाउँपालिका", englishLabel: "Miklajung Rural Municipality" }
        ]
      },
      {
        value: "sunsari", label: "सुनसरी", englishLabel: "Sunsari", palikas: [
          { value: "SUNSARI_ITAHARI_MUN", label: "ईटहरी उपमहानगरपालिका", englishLabel: "Itahari Sub-Metropolitan City" },
          { value: "SUNSARI_DHARAN_MUN", label: "धरान उपमहानगरपालिका", englishLabel: "Dharan Sub-Metropolitan City" },
          { value: "SUNSARI_INRUWA_MUN", label: "ईनरुवा नगरपालिका", englishLabel: "Inruwa Municipality" },
          { value: "SUNSARI_DUHAWI_MUN", label: "दुहवी नगरपालिका", englishLabel: "Duhawi Municipality" },
          { value: "SUNSARI_RAMDHUNI_MUN", label: "रामधुनी नगरपालिका", englishLabel: "Ramdhuni Municipality" },
          { value: "SUNSARI_BARAHAKSHETRA", label: "बराहक्षेत्र नगरपालिका", englishLabel: " Municipality" },
          { value: "SUNSARI_DEWANGANJ_MUN", label: "देवानगञ्ज गाउँपालिका", englishLabel: "Dewanganj Rural Municipality" },
          { value: "SUNSARI_KOSHI_MUN", label: "कोशी गाउँपालिका", englishLabel: "Koshi Rural Municipality" },
          { value: "SUNSARI_GADHI_MUN", label: "गढी गाउँपालिका", englishLabel: "Gadhi Rural Municipality" },
          { value: "SUNSARI_BARJU_MUN", label: "बर्जु गाउँपालिका", englishLabel: "Barju Rural Municipality" },
          { value: "SUNSARI_BHOKRAHA_NARSIHA_MUN", label: "भोक्राहा नरसिंह गाउँपालिका", englishLabel: "Bhokraha Narsiha Rural Municipality" },
          { value: "SUNSARI_HARINAGAR_MUN", label: "हरिनगर गाउँपालिका", englishLabel: "Harinagar Rural Municipality" }
        ]
      },
      {
        value: "dhankuta", label: "धनकुटा", englishLabel: "Dhankuta", palikas: [
          { value: "DHANKUTA_PAKHRIBAS_MUN", label: "पाख्रिबास नगरपालिका", englishLabel: "Pakhribas Municipality" },
          { value: "DHANKUTA_DHANKUTA_MUN", label: "धनकुटा नगरपालिका", englishLabel: "Dhankuta Municipality" },
          { value: "DHANKUTA_MAHALAXMI_MUN", label: "महालक्ष्मी नगरपालिका", englishLabel: "Mahalaxmi Municipality" },
          { value: "DHANKUTA_SAGURIGADHI_MUN", label: "साँगुरीगढी गाउँपालिका", englishLabel: "Sagurigadhi Rural Municipality" },
          { value: "DHANKUTA_SAHIDBHUMI_MUN", label: "सहिदभूमि गाउँपालिका", englishLabel: "Sahidbhumi Rural Municipality" },
          { value: "DHANKUTA_CHHATHAR_JORPATI_MUN", label: "छथर जोरपाटी गाउँपालिका", englishLabel: "Chhathar Jorpati Rural Municipality" },
          { value: "DHANKUTA_CHAUBISE_MUN", label: "चौविसे गाउँपालिका", englishLabel: "Chaubise Rural Municipality" }
        ]
      },
      {
        value: "tehrathum", label: "तेह्रथुम", englishLabel: "Tehrathum", palikas: [
          { value: "TEHRATHUM_MYANGLUNG_MUN", label: "म्याङलुङ नगरपालिका", englishLabel: "Myanglung Municipality" },
          { value: "TEHRATHUM_LALUGURAS_MUN", label: "लालीगुराँस नगरपालिका", englishLabel: "Laluguras Municipality" },
          { value: "TEHRATHUM_AATHRAI_MUN", label: "आठराई गाउँपालिका", englishLabel: "Aathrai Rural Municipality" },
          { value: "TEHRATHUM_CHHATHAR_MUN", label: "छथर गाउँपालिका", englishLabel: "Chhathar Rural Municipality" },
          { value: "TEHRATHUM_FEDAP_MUN", label: "फेदाप गाउँपालिका", englishLabel: "Fedap Rural Municipality" },
          { value: "TEHRATHUM_MENCHHAYAYEM_MUN", label: "मेन्छयायेम गाउँपालिका", englishLabel: "Menchhayayem Rural Municipality" }
        ]
      },
      {
        value: "sankhuwasabha", label: "संखुवासभा", englishLabel: "Sankhuwasabha", palikas: [
          { value: "SANKHUWASABHA_CHAINPUR_MUN", label: "चैनपुर नगरपालिका", englishLabel: "Chainpur Municipality" },
          { value: "SANKHUWASABHA_DHARMADEWI_MUN", label: "धर्मदेवी नगरपालिका", englishLabel: "Dharmadewi Municipality" },
          { value: "SANKHUWASABHA_KHADWARI_MUN", label: "खाँदवारी नगरपालिका", englishLabel: "Khadwari Municipality" },
          { value: "SANKHUWASABHA_MADI_MUN", label: "मादी नगरपालिका", englishLabel: "Madi Municipality" },
          { value: "SANKHUWASABHA_PACHKHAPAN_MUN", label: "पाँचखपन नगरपालिका", englishLabel: "Pachkhapan Municipality" },
          { value: "SANKHUWASABHA_BHOTKHOLA_MUN", label: "भोटखोला गाउँपालिका", englishLabel: "Bhotkhola Rural Municipality" },
          { value: "SANKHUWASABHA_CHICHILA_MUN", label: "चिचिला गाउँपालिका", englishLabel: "Chichila Rural Municipality" },
          { value: "SANKHUWASABHA_MAKALU_MUN", label: "मकालु गाउँपालिका", englishLabel: "Makalu Rural Municipality" },
          { value: "SANKHUWASABHA_SABHAPOKHARI_MUN", label: "सभापोखरी गाउँपालिका", englishLabel: "Sabhapokhari Rural Municipality" },
          { value: "SANKHUWASABHA_SILICHONG_MUN", label: "सिलीचोङ गाउँपालिका", englishLabel: "Silichong Rural Municipality" }
        ]
      },
      {
        value: "bhojpur", label: "भोजपुर", englishLabel: "Bhojpur", palikas: [
          { value: "BHOJPUR_BHOJPUR_MUN", label: "भोजपुर नगरपालिका", englishLabel: "Bhojpur Municipality" },
          { value: "BHOJPUR_SHADANANDA_MUN", label: "षडानन्द नगरपालिका", englishLabel: "Shadananda Municipality" },
          { value: "BHOJPUR_TEMKEMAIYUNG_MUN", label: "टेम्केमैयुङ गाउँपालिका", englishLabel: "Temkemaiyung Rural Municipality" },
          { value: "BHOJPUR_RAMPRASAD_RAI_MUN", label: "रामप्रसाद राई गाउँपालिका", englishLabel: "Ramprasad rai Rural Municipality" },
          { value: "BHOJPUR_ARUN_MUN", label: "अरुण गाउँपालिका", englishLabel: "Arun Rural Municipality" },
          { value: "BHOJPUR_PAUWAADUNGMA_MUN", label: "पौवादुङमा गाउँपालिका", englishLabel: "Pauwaadungma Rural Municipality" },
          { value: "BHOJPUR_SALPAASILICHHO_MUN", label: "साल्पासिलिछो गाउँपालिका", englishLabel: "Salpaasilichho Rural Municipality" },
          { value: "BHOJPUR_AAMCHOK", label: "आमचोक गाउँपालिका", englishLabel: " Rural Municipality" },
          { value: "BHOJPUR_HATUWAGADI", label: "हतुवागढी गाउँपालिका", englishLabel: " Rural Municipality" }
        ]
      },
      {
        value: "solukhumbu", label: "सोलुखुम्बु", englishLabel: "Solukhumbu", palikas: [
          { value: "SOLUKHUMBU_SOLUDUDHKUNDA_MUN", label: "सोलुदुधकुण्ड नगरपालिका", englishLabel: "Solududhkunda Municipality" },
          { value: "SOLUKHUMBU_MAPYA_DUDHKOSI_MUN", label: "माप्य दुधकोशी गाउँपालिका", englishLabel: "Mapya Dudhkosi Rural Municipality" },
          { value: "SOLUKHUMBU_KHUMWU_PASANGLHAMU_MUN", label: "खुम्वु पासाङल्हमु गाउँपालिका", englishLabel: "Khumbu Pasanglhamu Rural Municipality" },
          { value: "SOLUKHUMBU_THULUNG_DUDHKOSI_MUN", label: "थुलुङ दुधकोशी गाउँपालिका", englishLabel: "Thulung Dudhkosi Rural Municipality" },
          { value: "SOLUKHUMBU_NECHASALYAN_MUN", label: "नेचासल्यान गाउँपालिका", englishLabel: "Nechasalyan Rural Municipality" },
          { value: "SOLUKHUMBU_MAHAKULUNG_MUN", label: "माहाकुलुङ गाउँपालिका", englishLabel: "Mahakulung Rural Municipality" },
          { value: "SOLUKHUMBU_LIKHU_PIKE_MUN", label: "लिखु पिके गाउँपालिका", englishLabel: "Likhu Pike Rural Municipality" },
          { value: "SOLUKHUMBU_SOTANG_MUN", label: "सोताङ गाउँपालिका", englishLabel: "Sotang Rural Municipality" }
        ]
      },
      {
        value: "okhaldhunga", label: "ओखलढुङ्गा", englishLabel: "Okhaldhunga", palikas: [
          { value: "OKHALDHUNGA_SIDDHICHARAN_MUN", label: "सिद्दिचरण नगरपालिका", englishLabel: "Siddhicharan Municipality" },
          { value: "OKHALDHUNGA_KHIJIDEMBA_MUN", label: "खिजिदेम्बा गाउँपालिका", englishLabel: "Khijidemba Rural Municipality" },
          { value: "OKHALDHUNGA_CHAMPADEWI_MUN", label: "चम्पादेवी गाउँपालिका", englishLabel: "Champadewi Rural Municipality" },
          { value: "OKHALDHUNGA_CHISHANGKHUGADI_MUN", label: "चिशंखुगढी गाउँपालिका", englishLabel: "Chishangkhugadi Rural Municipality" },
          { value: "OKHALDHUNGA_MANEBHANGYANG_MUN", label: "मानेभञ्याङ गाउँपालिका", englishLabel: "Manebhangyang Rural Municipality" },
          { value: "OKHALDHUNGA_MOLUNG_MUN", label: "मोलुङ गाउँपालिका", englishLabel: "Molung Rural Municipality" },
          { value: "OKHALDHUNGA_LIKHU_MUN", label: "लिखु गाउँपालिका", englishLabel: "Likhu Rural Municipality" },
          { value: "OKHALDHUNGA_SUNKOSHI_MUN", label: "सुनकोशी गाउँपालिका", englishLabel: "Sunkoshi Rural Municipality" }
        ]
      },
      {
        value: "khotang", label: "खोटाङ", englishLabel: "Khotang", palikas: [
          { value: "KHOTANG_HALESI_TUWACHUNG_MUN", label: "हलेसी तुवाचुङ नगरपालिका", englishLabel: "Halesi Tuwachung Municipality" },
          { value: "KHOTANG_DIKTEL_RUPAKOT_MAJHUWAGADI_MUN", label: "दिक्तेल रुपाकोट मझुवागढी नगरपालिका", englishLabel: "Diktel Rupakot Majhuwagadi Municipality" },
          { value: "KHOTANG_YESELUKHARK_MUN", label: "ऐसेलुखर्क गाउँपालिका", englishLabel: "Yeselukhark Rural Municipality" },
          { value: "KHOTANG_RAWA_BESI_MUN", label: "रावा बेसी गाउँपालिका", englishLabel: "Rawa Besi Rural Municipality" },
          { value: "KHOTANG_JANTHEDHUNGA_MUN", label: "जन्तेढुंगा गाउँपालिका", englishLabel: "Janthedhunga Rural Municipality" },
          { value: "KHOTANG_KHOTEHANG_MUN", label: "खोटेहाङ गाउँपालिका", englishLabel: "Khotehang Rural Municipality" },
          { value: "KHOTANG_KEPILASGADI_MUN", label: "केपिलासगढी गाउँपालिका", englishLabel: "Kepilasgadi Rural Municipality" },
          { value: "KHOTANG_DIPRUNG_CHUICHUMMA_MUN", label: "दिप्रुङ चुइचुम्मा गाउँपालिका", englishLabel: "Diprung Chuichumma Rural Municipality" },
          { value: "KHOTANG_SAKELA_MUN", label: "साकेला गाउँपालिका", englishLabel: "Sakela Rural Municipality" },
          { value: "KHOTANG_WARAHAPOKHARI_MUN", label: "वराहपोखरी गाउँपालिका", englishLabel: "Barahapokhari Rural Municipality" }
        ]
      },
      {
        value: "udayapur", label: "उदयपुर", englishLabel: "Udayapur", palikas: [
          { value: "UDAYAPUR_KATARI_MUN", label: "कटारी नगरपालिका", englishLabel: "Katari Municipality" },
          { value: "UDAYAPUR_CHAUDANDIGADI_MUN", label: "चौदण्डीगढी नगरपालिका", englishLabel: "Chaudandigadi Municipality" },
          { value: "UDAYAPUR_TRIYUGA_MUN", label: "त्रियुगा नगरपालिका", englishLabel: "Triyuga Municipality" },
          { value: "UDAYAPUR_WELAKA_MUN", label: "वेलका नगरपालिका", englishLabel: "Welaka Municipality" },
          { value: "UDAYAPUR_UDAYAPURGADI_MUN", label: "उदयपुरगढी गाउँपालिका", englishLabel: "Udayapurgadi Rural Municipality" },
          { value: "UDAYAPUR_TAPLI_MUN", label: "ताप्ली गाउँपालिका", englishLabel: "Tapli Rural Municipality" },
          { value: "UDAYAPUR_RAUTAMAI_MUN", label: "रौतामाई गाउँपालिका", englishLabel: "Rautamai Rural Municipality" },
          { value: "UDAYAPUR_LIMCHUNGBUNG_MUN", label: "लिम्चुङ्बुङ गाउँपालिका", englishLabel: "Limchungbung Rural Municipality" }
        ]
      }]
  },
  {
    value: "PROVIENCE_2", label: "मधेश प्रदेश", englishLabel: "Madhesh Province", districts: [
      {
        value: "saptari", label: "सप्तरी", englishLabel: "Saptari", palikas: [
          { value: "SAPTARI_RAJWIRAJ_MUN", label: "राजविराज नगरपालिका", englishLabel: "Rajwiraj Municipality" },
          { value: "SAPTARI_KANCHANRUP_MUN", label: "कञ्चनरुप नगरपालिका", englishLabel: "Kanchanrup Municipality" },
          { value: "SAPTARI_DAKNESHOWRI_MUN", label: "डाक्नेश्वरी नगरपालिका", englishLabel: "Dakneshowri Municipality" },
          { value: "SAPTARI_BODEBARASAIN_MUN", label: "बोदेबरसाईन नगरपालिका", englishLabel: "Bodebarasain Municipality" },
          { value: "SAPTARI_KHADAK_MUN", label: "खडक नगरपालिका", englishLabel: "Khadak Municipality" },
          { value: "SAPTARI_SHAMBHUNATH_MUN", label: "शम्भुनाथ नगरपालिका", englishLabel: "Shambhunath Municipality" },
          { value: "SAPTARI_SURUNGA_MUN", label: "सुरुङ्गा नगरपालिका", englishLabel: "Surunga Municipality" },
          { value: "SAPTARI_HANUMANNAGAR_KANGKALINI_MUN", label: "हनुमाननगर कङ्कालिनी नगरपालिका", englishLabel: "Hanumannagar Kangkalini Municipality" },
          { value: "SAPTARI_SAPTAKOSI_MUN", label: "सप्तकोशी नगरपालिका", englishLabel: "Saptakosi Municipality" },
          { value: "SAPTARI_AGNISAIR_KRISHNASARAWAN_MUN", label: "अग्निसाइर कृष्णासरवन गाउँपालिका", englishLabel: "Agnisair Krishnasarawan Rural Municipality" },
          { value: "SAPTARI_CHHINNAMASTA_MUN", label: "छिन्नमस्ता गाउँपालिका", englishLabel: "Chhinnamasta Rural Municipality" },
          { value: "SAPTARI_MAHADEWA_MUN", label: "महादेवा गाउँपालिका", englishLabel: "Mahadewa Rural Municipality" },
          { value: "SAPTARI_TIRAHUT_MUN", label: "तिरहुत गाउँपालिका", englishLabel: "Tirahut Rural Municipality" },
          { value: "SAPTARI_TILATHI_KOILADI_MUN", label: "तिलाठी कोईलाडी गाउँपालिका", englishLabel: "Tilathi Koiladi Rural Municipality" },
          { value: "SAPTARI_RUPANI_MUN", label: "रुपनी गाउँपालिका", englishLabel: "Rupani Rural Municipality" },
          { value: "SAPTARI_RAJGAD_MUN", label: "राजगढ गाउँपालिका", englishLabel: "Rajgad Rural Municipality" },
          { value: "SAPTARI_BISHNUPUR_MUN", label: "बिष्णुपुर गाउँपालिका", englishLabel: "Bishnupur Rural Municipality" },
          { value: "SAPTARI_BALAN_BIHUL_MUN", label: "बलान-बिहुल गाउँपालिका", englishLabel: "Balan Bihul Rural Municipality" }
        ]
      },
      {
        value: "siraha", label: "सिरहा", englishLabel: "Siraha", palikas: [
          { value: "SIRAHA_LAHAN_MUN", label: "लहान नगरपालिका", englishLabel: "Lahan Municipality" },
          { value: "SIRAHA_DHANGADIMAI_MUN", label: "धनगढीमाई नगरपालिका", englishLabel: "Dhangadimai Municipality" },
          { value: "SIRAHA_SIRAHA_MUN", label: "सिरहा नगरपालिका", englishLabel: "Siraha Municipality" },
          { value: "SIRAHA_GOLBAJAR_MUN", label: "गोलबजार नगरपालिका", englishLabel: "Golbajar Municipality" },
          { value: "SIRAHA_MIRCHAIYA_MUN", label: "मिर्चैयाँ नगरपालिका", englishLabel: "Mirchaiya Municipality" },
          { value: "SIRAHA_KALYANPUR_MUN", label: "कल्याणपुर नगरपालिका", englishLabel: "Kalyanpur Municipality" },
          { value: "SIRAHA_KARJANHA_MUN", label: "कर्जन्हा नगरपालिका", englishLabel: "Karjanha Municipality" },
          { value: "SIRAHA_SUKHIPUR_MUN", label: "सुखीपुर नगरपालिका", englishLabel: "Sukhipur Municipality" },
          { value: "SIRAHA_BHAGAWANPUR_MUN", label: "भगवानपुर गाउँपालिका", englishLabel: "Bhagawanpur Rural Municipality" },
          { value: "SIRAHA_AAURAHI_MUN", label: "औरही गाउँपालिका", englishLabel: "Aaurahi Rural Municipality" },
          { value: "SIRAHA_WISHNUPUR_MUN", label: "विष्णुपुर गाउँपालिका", englishLabel: "Wishnupur Rural Municipality" },
          { value: "SIRAHA_BARIYARPATTI_MUN", label: "बरियारपट्टी गाउँपालिका", englishLabel: "Bariyarpatti Rural Municipality" },
          { value: "SIRAHA_LAXMIPUR_PATARI_MUN", label: "लक्ष्मीपुर पतारी गाउँपालिका", englishLabel: "Laxmipur Patari Rural Municipality" },
          { value: "SIRAHA_NARAHA_MUN", label: "नरहा गाउँपालिका", englishLabel: "Naraha Rural Municipality" },
          { value: "SIRAHA_SANKHUWANANKARAKATTI_MUN", label: "सखुवानान्कारकट्टी गाउँपालिका", englishLabel: "Sankhuwanankarakatti Rural Municipality" },
          { value: "SIRAHA_ARNAMA_MUN", label: "अर्नमा गाउँपालिका", englishLabel: "Arnama Rural Municipality" },
          { value: "SIRAHA_NAWARAJPUR_MUN", label: "नवराजपुर गाउँपालिका", englishLabel: "Nawarajpur Rural Municipality" }
        ]
      },
      {
        value: "dhanusa", label: "धनुषा", englishLabel: "Dhanusa", palikas: [
          { value: "DHANUSA_JANAKPURDHAM_MUN", label: "जनकपुरधाम उपमहानगरपालिका", englishLabel: "Janakpurdham Sub-Metropolitan City" },
          { value: "DHANUSA_KSHIRESHWORNATH_MUN", label: "क्षिरेश्वरनाथ नगरपालिका", englishLabel: "Kshireshwornath Municipality" },
          { value: "DHANUSA_GANESHMAN_CHARNATH_MUN", label: "गणेशमान चारनाथ नगरपालिका", englishLabel: "Ganeshman Charnath Municipality" },
          { value: "DHANUSA_DHANUSHADHAM_MUN", label: "धनुषाधाम नगरपालिका", englishLabel: "Dhanushadham Municipality" },
          { value: "DHANUSA_NAGRAIN_MUN", label: "नगराइन नगरपालिका", englishLabel: "Nagrain Municipality" },
          { value: "DHANUSA_WIDEHA_MUN", label: "विदेह नगरपालिका", englishLabel: "Wideha Municipality" },
          { value: "DHANUSA_MITHILA_MUN", label: "मिथिला नगरपालिका", englishLabel: "Mithila Municipality" },
          { value: "DHANUSA_SHAHIDNAGAR_MUN", label: "शहीदनगर नगरपालिका", englishLabel: "Shahidnagar Municipality" },
          { value: "DHANUSA_SABAILA_MUN", label: "सबैला नगरपालिका", englishLabel: "Sabaila Municipality" },
          { value: "DHANUSA_KAMALA_MUN", label: "कमला नगरपालिका", englishLabel: "Kamala Municipality" },
          { value: "DHANUSA_MITHILA_BIHARI_MUN", label: "मिथिला बिहारी नगरपालिका", englishLabel: "Mithila Bihari Municipality" },
          { value: "DHANUSA_HANSAPUR_MUN", label: "हंसपुर नगरपालिका", englishLabel: "Hansapur Municipality" },
          { value: "DHANUSA_JANAKNANDINI_MUN", label: "जनकनन्दिनी गाउँपालिका", englishLabel: "Janaknandini Rural Municipality" },
          { value: "DHANUSA_BATESHOWER_MUN", label: "बटेश्वर गाउँपालिका", englishLabel: "Bateshower Rural Municipality" },
          { value: "DHANUSA_MUKHIYAPATTI_MUSAHARMIYA_MUN", label: "मुखियापट्टी मुसहरमिया गाउँपालिका", englishLabel: "Mukhiyapatti Musaharmiya Rural Municipality" },
          { value: "DHANUSA_LAXMINIYA_MUN", label: "लक्ष्मीनिया गाउँपालिका", englishLabel: "Laxminiya Rural Municipality" },
          { value: "DHANUSA_AAURAHI_MUN", label: "औरही गाउँपालिका", englishLabel: "Aaurahi Rural Municipality" },
          { value: "DHANUSA_DHANAUJI_MUN", label: "धनौजी गाउँपालिका", englishLabel: "Dhanauji Rural Municipality" }
        ]
      },
      {
        value: "mahottari", label: "महोत्तरी", englishLabel: "Mahottari", palikas: [
          { value: "MAHOTTARI_JALESHOWER_MUN", label: "जलेश्वर नगरपालिका", englishLabel: "Jaleshower Municipality" },
          { value: "MAHOTTARI_BARDIBAS_MUN", label: "बर्दिबास नगरपालिका", englishLabel: "Bardibas Municipality" },
          { value: "MAHOTTARI_GAUSALA_MUN", label: "गौशाला नगरपालिका", englishLabel: "Gausala Municipality" },
          { value: "MAHOTTARI_LOHALPATTI_MUN", label: "लोहरपट्टी नगरपालिका", englishLabel: "Lohalpatti Municipality" },
          { value: "MAHOTTARI_RAMGOPALPUR_MUN", label: "रामगोपालपुर नगरपालिका", englishLabel: "Ramgopalpur Municipality" },
          { value: "MAHOTTARI_MANARA_SHISAWA_MUN", label: "मनरा शिसवा नगरपालिका", englishLabel: "Manara Shisawa Municipality" },
          { value: "MAHOTTARI_MATIHANI_MUN", label: "मटिहानी नगरपालिका", englishLabel: "Matihani Municipality" },
          { value: "MAHOTTARI_BHANGAHA_MUN", label: "भँगाहा नगरपालिका", englishLabel: "Bhangaha Municipality" },
          { value: "MAHOTTARI_BALAWA_MUN", label: "बलवा नगरपालिका", englishLabel: "Balawa Municipality" },
          { value: "MAHOTTARI_AAURAHI_MUN", label: "औरही नगरपालिका", englishLabel: "Aaurahi Municipality" },
          { value: "MAHOTTARI_EKDARA_MUN", label: "एकडारा गाउँपालिका", englishLabel: "Ekdara Rural Municipality" },
          { value: "MAHOTTARI_SONAMA_MUN", label: "सोनमा गाउँपालिका", englishLabel: "Sonama Rural Municipality" },
          { value: "MAHOTTARI_SAMSI_MUN", label: "साम्सी गाउँपालिका", englishLabel: "Samsi Rural Municipality" },
          { value: "MAHOTTARI_MAHOTTARI_MUN", label: "महोत्तरी गाउँपालिका", englishLabel: "Mahottari Rural Municipality" },
          { value: "MAHOTTARI_PIPARA_MUN", label: "पिपरा गाउँपालिका", englishLabel: "Pipara Rural Municipality" }
        ]
      },
      {
        value: "sarlahi", label: "सर्लाही", englishLabel: "Sarlahi", palikas: [
          { value: "SARLAHI_ISHWORPUR_MUN", label: "ईश्वरपुर नगरपालिका", englishLabel: "Ishworpur Municipality" },
          { value: "SARLAHI_MANGALGAWA_MUN", label: "मलंगवा नगरपालिका", englishLabel: "Mangalgawa Municipality" },
          { value: "SARLAHI_LALBANDI_MUN", label: "लालबन्दी नगरपालिका", englishLabel: "Lalbandi Municipality" },
          { value: "SARLAHI_HARIPUR_MUN", label: "हरिपुर नगरपालिका", englishLabel: "Haripur Municipality" },
          { value: "SARLAHI_HARIPURWA_MUN", label: "हरिपुर्वा नगरपालिका", englishLabel: "Haripurwa Municipality" },
          { value: "SARLAHI_HARIWAN_MUN", label: "हरिवन नगरपालिका", englishLabel: "Hariwan Municipality" },
          { value: "SARLAHI_BARAHATHAWA_MUN", label: "बरहथवा नगरपालिका", englishLabel: "Barahathawa Municipality" },
          { value: "SARLAHI_BALARA_MUN", label: "बलरा नगरपालिका", englishLabel: "Balara Municipality" },
          { value: "SARLAHI_GODAITA_MUN", label: "गोडैटा नगरपालिका", englishLabel: "Godaita Municipality" },
          { value: "SARLAHI_BAGAMATI_MUN", label: "बागमती नगरपालिका", englishLabel: "Bagamati Municipality" },
          { value: "SARLAHI_KAWILASI_MUN", label: "कविलासी नगरपालिका", englishLabel: "Kawilasi Municipality" },
          { value: "SARLAHI_CHAKRAGHATTA_MUN", label: "चक्रघट्टा गाउँपालिका", englishLabel: "Chakraghatta Rural Municipality" },
          { value: "SARLAHI_CHANDRANAGAR_MUN", label: "चन्द्रनगर गाउँपालिका", englishLabel: "Chandranagar Rural Municipality" },
          { value: "SARLAHI_DHANKAUL_MUN", label: "धनकौल गाउँपालिका", englishLabel: "Dhankaul Rural Municipality" },
          { value: "SARLAHI_BRHAPURI_MUN", label: "ब्रह्मपुरी गाउँपालिका", englishLabel: "Brhapuri Rural Municipality" },
          { value: "SARLAHI_RAMNAGAR_MUN", label: "रामनगर गाउँपालिका", englishLabel: "Ramnagar Rural Municipality" },
          { value: "SARLAHI_BISHNU_MUN", label: "विष्णु गाउँपालिका", englishLabel: "Bishnu Rural Municipality" },
          { value: "SARLAHI_KAUDENA_MUN", label: "कौडेना गाउँपालिका", englishLabel: "Kaudena Rural Municipality" },
          { value: "SARLAHI_PARSA_MUN", label: "पर्सा गाउँपालिका", englishLabel: "Parsa Rural Municipality" },
          { value: "SARLAHI_BASABARIYA_MUN", label: "बसबरीया गाउँपालिका", englishLabel: "Basabariya Rural Municipality" }
        ]
      },
      {
        value: "rautahat", label: "रौतहट", englishLabel: "Rautahat", palikas: [
          { value: "RAUTAHAT_CHANDRAPUR_MUN", label: "चन्द्रपुर नगरपालिका", englishLabel: "Chandrapur Municipality" },
          { value: "RAUTAHAT_GARUDA_MUN", label: "गरुडा नगरपालिका", englishLabel: "Garuda Municipality" },
          { value: "RAUTAHAT_GAUR_MUN", label: "गौर नगरपालिका", englishLabel: "Gaur Municipality" },
          { value: "RAUTAHAT_BAUDHIMAI_MUN", label: "बौधीमाई नगरपालिका", englishLabel: "Baudhimai Municipality" },
          { value: "RAUTAHAT_BRINDAWAN_MUN", label: "बृन्दावन नगरपालिका", englishLabel: "Brindawan Municipality" },
          { value: "RAUTAHAT_DEWAHI_GONAHI_MUN", label: "देवाही गोनाही नगरपालिका", englishLabel: "Dewahi Gonahi Municipality" },
          { value: "RAUTAHAT_GADIMAI_MUN", label: "गढीमाई नगरपालिका", englishLabel: "Gadimai Municipality" },
          { value: "RAUTAHAT_GUJARA_MUN", label: "गुजरा नगरपालिका", englishLabel: "Gujara Municipality" },
          { value: "RAUTAHAT_KATAHARIYA", label: "कटहरिया नगरपालिका", englishLabel: " Municipality" },
          { value: "RAUTAHAT_MADHAWA_NARAYAN_MUN", label: "माधव नारायण नगरपालिका", englishLabel: "Madhawa Narayan Municipality" },
          { value: "RAUTAHAT_MAULAPUR_MUN", label: "मौलापुर नगरपालिका", englishLabel: "Maulapur Municipality" },
          { value: "RAUTAHAT_FATUWABIJAYAPUR_MUN", label: "फतुवाबिजयपुर नगरपालिका", englishLabel: "Fatuwabijayapur Municipality" },
          { value: "RAUTAHAT_ISHANATH_MUN", label: "ईशनाथ नगरपालिका", englishLabel: "Ishanath Municipality" },
          { value: "RAUTAHAT_PAROHA_MUN", label: "परोहा नगरपालिका", englishLabel: "Paroha Municipality" },
          { value: "RAUTAHAT_RAJPUR_MUN", label: "राजपुर नगरपालिका", englishLabel: "Rajpur Municipality" },
          { value: "RAUTAHAT_RAJDEWI_MUN", label: "राजदेवी नगरपालिका", englishLabel: "Rajdewi Municipality" },
          { value: "RAUTAHAT_DURGA_BHAGAWATI_MUN", label: "दुर्गा भगवती गाउँपालिका", englishLabel: "Durga Bhagawati Rural Municipality" },
          { value: "RAUTAHAT_YAMUNAMAI_MUN", label: "यमुनामाई गाउँपालिका", englishLabel: "Yamunamai Rural Municipality" }
        ]
      },
      {
        value: "bara", label: "बारा", englishLabel: "Bara", palikas: [
          { value: "BARA_KALAIYA_MUN", label: "कलैया उपमहानगरपालिका", englishLabel: "Kalaiya Sub-Metropolitan City" },
          { value: "BARA_JITPUR_SIMARA_MUN", label: "जीतपुर सिमरा उपमहानगरपालिका", englishLabel: "Jitpur Simara Sub-Metropolitan City" },
          { value: "BARA_KOLHAWI_MUN", label: "कोल्हवी नगरपालिका", englishLabel: "Kolhawi Municipality" },
          { value: "BARA_NIJGOD_MUN", label: "निजगढ नगरपालिका", englishLabel: "Nijgadh Municipality" },
          { value: "BARA_MAHAGADIMAI_MUN", label: "महागढीमाई नगरपालिका", englishLabel: "Mahagadimai Municipality" },
          { value: "BARA_SIMRAUNGOD_MUN", label: "सिम्रौनगढ नगरपालिका", englishLabel: "Simraungod Municipality" },
          { value: "BARA_PACHARAUTA_MUN", label: "पचरौता नगरपालिका", englishLabel: "Pacharauta Municipality" },
          { value: "BARA_AADARSHA_KOTAWAL_MUN", label: "आदर्श कोटवाल गाउँपालिका", englishLabel: "Aadarsha Kotawal Rural Municipality" },
          { value: "BARA_KARAIYAMAI_MUN", label: "करैयामाई गाउँपालिका", englishLabel: "Karaiyamai Rural Municipality" },
          { value: "BARA_DEWATAL_MUN", label: "देवताल गाउँपालिका", englishLabel: "Dewatal Rural Municipality" },
          { value: "BARA_PARAWANIPUR_MUN", label: "परवानीपुर गाउँपालिका", englishLabel: "Parawanipur Rural Municipality" },
          { value: "BARA_PRASAUNI_MUN", label: "प्रसौनी गाउँपालिका", englishLabel: "Prasauni Rural Municipality" },
          { value: "BARA_FETA_MUN", label: "फेटा गाउँपालिका", englishLabel: "Feta Rural Municipality" },
          { value: "BARA_BARAGADI_MUN", label: "बारागढी गाउँपालिका", englishLabel: "Baragadi Rural Municipality" },
          { value: "BARA_SUWARNA_MUN", label: "सुवर्ण गाउँपालिका", englishLabel: "Suwarna Rural Municipality" },
          { value: "BARA_WISHRAMPUR_MUN", label: "विश्रामपुर गाउँपालिका", englishLabel: "Wishrampur Rural Municipality" }
        ]
      },
      {
        value: "parsa", label: "पर्सा", englishLabel: "Parsa", palikas: [
          { value: "PARSA_BIRJUNG_MUN", label: "बिरगंज महानगरपालिका", englishLabel: "Birjung Metropolitan City" },
          { value: "PARSA_POKHARIYA_MUN", label: "पोखरिया नगरपालिका", englishLabel: "Pokhariya Municipality" },
          { value: "PARSA_BAHUDARMAI_MUN", label: "बहुदरमाई नगरपालिका", englishLabel: "Bahudarmai Municipality" },
          { value: "PARSA_PARSAGADI_MUN", label: "पर्सागढी नगरपालिका", englishLabel: "Parsagadi Municipality" },
          { value: "PARSA_THORI_MUN", label: "ठोरी गाउँपालिका", englishLabel: "Thori Rural Municipality" },
          { value: "PARSA_JAGARNATHPUR_MUN", label: "जगरनाथपुर गाउँपालिका", englishLabel: "Jagarnathpur Rural Municipality" },
          { value: "PARSA_DHOBINI_MUN", label: "धोबीनी गाउँपालिका", englishLabel: "Dhobini Rural Municipality" },
          { value: "PARSA_CHHIPAHARMAI_MUN", label: "छिपहरमाई गाउँपालिका", englishLabel: "Chhipaharmai Rural Municipality" },
          { value: "PARSA_PAKAHA_MAINAPUR_MUN", label: "पकाहा मैनपुर गाउँपालिका", englishLabel: "Pakaha Mainapur Rural Municipality" },
          { value: "PARSA_BINDABASINI_MUN", label: "बिन्दबासिनी गाउँपालिका", englishLabel: "Bindabasini Rural Municipality" },
          { value: "PARSA_SAKHUWA_PRASAUNI_MUN", label: "सखुवा प्रसौनी गाउँपालिका", englishLabel: "Sakhuwa Prasauni Rural Municipality" },
          { value: "PARSA_PATERWA_SUGAULI_MUN", label: "पटेर्वा सुगौली गाउँपालिका", englishLabel: "Paterwa Sugauli Rural Municipality" },
          { value: "PARSA_KALIKAMAI_MUN", label: "कालिकामाई गाउँपालिका", englishLabel: "Kalikamai Rural Municipality" },
          { value: "PARSA_JIRA_BHAWANI_MUN", label: "जिरा भवानी गाउँपालिका", englishLabel: "Jira Bhawani Rural Municipality" }
        ]
      }
    ]
  },
  {
    value: "PROVINCE_3", label: "बागमती प्रदेश", englishLabel: "Bagmati Province", districts: [
      {
        value: "sindhuli", label: "सिन्धुली", englishLabel: "Sindhuli", palikas: [
          { value: "SINDHULI_KAMALAMAI_MUN", label: "कमलामाई नगरपालिका", englishLabel: "Kamalamai Municipality" },
          { value: "SINDHULI_DUDHAULI_MUN", label: "दुधौली नगरपालिका", englishLabel: "Dudhauli Municipality" },
          { value: "SINDHULI_GOLANJAR_MUN", label: "गोलन्जर गाउँपालिका", englishLabel: "Golanjar Rural Municipality" },
          { value: "SINDHULI_GHYANGLEKH_MUN", label: "घ्याङलेख गाउँपालिका", englishLabel: "Ghyanglekh Rural Municipality" },
          { value: "SINDHULI_TINPATAN_MUN", label: "तीनपाटन गाउँपालिका", englishLabel: "Tinpatan Rural Municipality" },
          { value: "SINDHULI_FIKKAL_MUN", label: "फिक्कल गाउँपालिका", englishLabel: "Fikkal Rural Municipality" },
          { value: "SINDHULI_MARIN_MUN", label: "मरिण गाउँपालिका", englishLabel: "Marin Rural Municipality" },
          { value: "SINDHULI_SUNKOSHI_MUN", label: "सुनकोशी गाउँपालिका", englishLabel: "Sunkoshi Rural Municipality" },
          { value: "SINDHULI_HARIHARPURGADI_MUN", label: "हरिहरपुरगढी गाउँपालिका", englishLabel: "Hariharpurgadi Rural Municipality" }
        ]
      },
      {
        value: "ramechhap", label: "रामेछाप", englishLabel: "Ramechhap", palikas: [
          { value: "RAMECHHAP_MANTHALI_MUN", label: "मन्थली नगरपालिका", englishLabel: "Manthali Municipality" },
          { value: "RAMECHHAP_RAMECHHAP_MUN", label: "रामेछाप नगरपालिका", englishLabel: "Ramechhap Municipality" },
          { value: "RAMECHHAP_UMAKUNDA_MUN", label: "उमाकुण्ड गाउँपालिका", englishLabel: "Umakunda Rural Municipality" },
          { value: "RAMECHHAP_KHADADEWI_MUN", label: "खाँडादेवी गाउँपालिका", englishLabel: "Khadadewi Rural Municipality" },
          { value: "RAMECHHAP_GOKULDHUNGA_MUN", label: "गोकुलगङ्गा गाउँपालिका", englishLabel: "Gokuldhunga Rural Municipality" },
          { value: "RAMECHHAP_DORAMBA_MUN", label: "दोरम्बा गाउँपालिका", englishLabel: "Doramba Rural Municipality" },
          { value: "RAMECHHAP_LIKHU_TAMAKOSHI_MUN", label: "लिखु तामाकोशी गाउँपालिका", englishLabel: "Likhu Tamakoshi Rural Municipality" },
          { value: "RAMECHHAP_SUNAPATI_MUN", label: "सुनापती गाउँपालिका", englishLabel: "Sunapati Rural Municipality" }
        ]
      },
      {
        value: "dolakha", label: "दोलखा", englishLabel: "Dolakha", palikas: [
          { value: "DOLAKHA_JIRI_MUN", label: "जिरी नगरपालिका", englishLabel: "Jiri Municipality" },
          { value: "DOLAKHA_BHIMESHOWER_MUN", label: "भिमेश्वर नगरपालिका", englishLabel: "Bhimeshower Municipality" },
          { value: "DOLAKHA_KALINCHOK_MUN", label: "कालिन्चोक गाउँपालिका", englishLabel: "Kalinchok Rural Municipality" },
          { value: "DOLAKHA_GAURISHANKAR_MUN", label: "गौरीशङ्कर गाउँपालिका", englishLabel: "Gaurishankar Rural Municipality" },
          { value: "DOLAKHA_TAMAKOSHI_MUN", label: "तामाकोशी गाउँपालिका", englishLabel: "Tamakoshi Rural Municipality" },
          { value: "DOLAKHA_MELUNG_MUN", label: "मेलुङ्ग गाउँपालिका", englishLabel: "Melung Rural Municipality" },
          { value: "DOLAKHA_WIGU_MUN", label: "विगु गाउँपालिका", englishLabel: "Wigu Rural Municipality" },
          { value: "DOLAKHA_WAITESHOWER_MUN", label: "वैतेश्वर गाउँपालिका", englishLabel: "Baiteshower Rural Municipality" },
          { value: "DOLAKHA_SHAILING_MUN", label: "शैलुङ्ग गाउँपालिका", englishLabel: "Shailing Rural Municipality" }
        ]
      },
      {
        value: "sindhupalchok", label: "सिन्धुपाल्चोक", englishLabel: "Sindhupalchok", palikas: [
          { value: "SINDHUPALCHOK_CHAUTARA_SANGACHOKGADI_MUN", label: "चौतारा साँगाचोकगढी नगरपालिका", englishLabel: "Chautara Sangachokgadi Municipality" },
          { value: "SINDHUPALCHOK_BAHRAWISE_MUN", label: "बाह्रविसे नगरपालिका", englishLabel: "Bahrawise Municipality" },
          { value: "SINDHUPALCHOK_MELAMCHI_MUN", label: "मेलम्ची नगरपालिका", englishLabel: "Melamchi Municipality" },
          { value: "SINDHUPALCHOK_INDRAWATI_MUN", label: "ईन्द्रावती गाउँपालिका", englishLabel: "Indrawati Rural Municipality" },
          { value: "SINDHUPALCHOK_JUGAL_MUN", label: "जुगल गाउँपालिका", englishLabel: "Jugal Rural Municipality" },
          { value: "SINDHUPALCHOK_PACHPOKHARI_THANGPAL_MUN", label: "पाँचपोखरी थाङपाल गाउँपालिका", englishLabel: "Pachpokhari Thangpal Rural Municipality" },
          { value: "SINDHUPALCHOK_BALEFI_MUN", label: "बलेफी गाउँपालिका", englishLabel: "Balefi Rural Municipality" },
          { value: "SINDHUPALCHOK_BHOTEKOSHI_MUN", label: "भोटेकोशी गाउँपालिका", englishLabel: "Bhotekoshi Rural Municipality" },
          { value: "SINDHUPALCHOK_LISANGKHU_PAKHAR_MUN", label: "लिसङ्खु पाखर गाउँपालिका", englishLabel: "Lisangkhu Pakhar Rural Municipality" },
          { value: "SINDHUPALCHOK_SUNKOSHI_MUN", label: "सुनकोशी गाउँपालिका", englishLabel: "Sunkoshi Rural Municipality" },
          { value: "SINDHUPALCHOK_HELAMBU_MUN", label: "हेलम्बु गाउँपालिका", englishLabel: "Helambu Rural Municipality" },
          { value: "SINDHUPALCHOK_TRIPURASUNDARI_MUN", label: "त्रिपुरासुन्दरी गाउँपालिका", englishLabel: "Tripurasundari Rural Municipality" }
        ]
      },
      {
        value: "kabhre", label: "काभ्रे", englishLabel: "Kabhre", palikas: [
          { value: "KABHRE_DHULIKHEL_MUN", label: "धुलिखेल नगरपालिका", englishLabel: "Dhulikhel Municipality" },
          { value: "KABHRE_BANEPA_MUN", label: "बनेपा नगरपालिका", englishLabel: "Banepa Municipality" },
          { value: "KABHRE_PANAUTI_MUN", label: "पनौती नगरपालिका", englishLabel: "Panauti Municipality" },
          { value: "KABHRE_PACHKHAL_MUN", label: "पाँचखाल नगरपालिका", englishLabel: "Pachkhal Municipality" },
          { value: "KABHRE_NAMOBUDDHA_MUN", label: "नमोबुद्ध नगरपालिका", englishLabel: "Namobuddha Municipality" },
          { value: "KABHRE_MANDANDEUPUR_MUN", label: "मण्डनदेउपुर नगरपालिका", englishLabel: "Mandandeupur Municipality" },
          { value: "KABHRE_KHANIKHOLA_MUN", label: "खानीखोला गाउँपालिका", englishLabel: "Khanikhola Rural Municipality" },
          { value: "KABHRE_CHURIDEURALI_MUN", label: "चौंरीदेउराली गाउँपालिका", englishLabel: "Churideurali Rural Municipality" },
          { value: "KABHRE_TEMAL_MUN", label: "तेमाल गाउँपालिका", englishLabel: "Temal Rural Municipality" },
          { value: "KABHRE_BETHANCHOK_MUN", label: "बेथानचोक गाउँपालिका", englishLabel: "Bethanchok Rural Municipality" },
          { value: "KABHRE_BHUMLU_MUN", label: "भुम्लु गाउँपालिका", englishLabel: "Bhumlu Rural Municipality" },
          { value: "KABHRE_MAHABHARAT_MUN", label: "महाभारत गाँउपालिका", englishLabel: "Mahabharat" },
          { value: "KABHRE_ROSHI_MUN", label: "रोशी गाउँपालिका", englishLabel: "Roshi Rural Municipality" }
        ]
      },
      {
        value: "lalitpur", label: "ललितपुर", englishLabel: "Lalitpur", palikas: [
          { value: "LALITPUR_LALITPUR_MUN", label: "ललितपुर महानगरपालिका", englishLabel: "Lalitpur Metropolitan City" },
          { value: "LALITPUR_GODAWARI_MUN", label: "गोदावरी नगरपालिका", englishLabel: "Godawari Municipality" },
          { value: "LALITPUR_MAHALAXMI_MUN", label: "महालक्ष्मी नगरपालिका", englishLabel: "Mahalaxmi Municipality" },
          { value: "LALITPUR_KONJYOSOM_MUN", label: "कोन्ज्योसोम गाउँपालिका", englishLabel: "Konjyosom Rural Municipality" },
          { value: "LALITPUR_BAGAMATI_MUN", label: "बागमती गाउँपालिका", englishLabel: "Bagamati Rural Municipality" },
          { value: "LALITPUR_MAHANGKAL_MUN", label: "महाङ्काल गाउँपालिका", englishLabel: "Mahangkal Rural Municipality" }
        ]
      },
      {
        value: "bhaktapur", label: "भक्तपुर", englishLabel: "Bhaktapur", palikas: [
          { value: "BHAKTAPUR_CHAGUNARAYAN_MUN", label: "चाँगुनारायण नगरपालिका", englishLabel: "Chagunarayan Municipality" },
          { value: "BHAKTAPUR_BHAKTAPUR_MUN", label: "भक्तपुर नगरपालिका", englishLabel: "Bhaktapur Municipality" },
          { value: "BHAKTAPUR_MADHYAPUR_THIMI_MUN", label: "मध्यपुर थिमी नगरपालिका", englishLabel: "Madhyapur Thimi Municipality" },
          { value: "BHAKTAPUR_SURYABINAYAK_MUN", label: "सूर्यविनायक नगरपालिका", englishLabel: "Suryabinayak Municipality" }
        ]
      },
      {
        value: "kathmandu", label: "काठमाडौं", englishLabel: "Kathmandu", palikas: [
          { value: "KATHMANDU_KATHMANDU_MUN", label: "काठमाण्डौं महानगरपालिका", englishLabel: "Kathmandu Metropolitan City" },
          { value: "KATHMANDU_KAGESHOWRI_MANOHARA_MUN", label: "कागेश्वरी मनोहरा नगरपालिका", englishLabel: "Kageshowri Manohara Municipality" },
          { value: "KATHMANDU_KRITIPUR_MUN", label: "कीर्तिपुर नगरपालिका", englishLabel: "Kritipur Municipality" },
          { value: "KATHMANDU_GOKARNESHOWER_MUN", label: "गोकर्णेश्वर नगरपालिका", englishLabel: "Gokarneshower Municipality" },
          { value: "KATHMANDU_CHANDRAGIRI_MUN", label: "चन्द्रागिरी नगरपालिका", englishLabel: "Chandragiri Municipality" },
          { value: "KATHMANDU_TOKHA_MUN", label: "टोखा नगरपालिका", englishLabel: "Tokha Municipality" },
          { value: "KATHMANDU_TAEKESHOWER_MUN", label: "तारकेश्वर नगरपालिका", englishLabel: "Taekeshower Municipality" },
          { value: "KATHMANDU_DAKSHINKALI_MUN", label: "दक्षिणकाली नगरपालिका", englishLabel: "Dakshinkali Municipality" },
          { value: "KATHMANDU_NAGARJUNA_MUN", label: "नागार्जुन नगरपालिका", englishLabel: "Nagarjuna Municipality" },
          { value: "KATHMANDU_BUDANILAKANTHA_MUN", label: "बुढानिलकण्ठ नगरपालिका", englishLabel: "Budanilakantha Municipality" },
          { value: "KATHMANDU_SHANKHARAPUR_MUN", label: "शङ्खरापुर नगरपालिका", englishLabel: "Shankharapur Municipality" }
        ]
      },
      {
        value: "nuwakot", label: "नुवाकोट", englishLabel: "Nuwakot", palikas: [
          { value: "NUWAKOT_BIDUR_MUN", label: "विदुर नगरपालिका", englishLabel: "Bidur Municipality" },
          { value: "NUWAKOT_BELKOTGADI_MUN", label: "बेलकोटगढी नगरपालिका", englishLabel: "Belkotgadi Municipality" },
          { value: "NUWAKOT_KAKANI_MUN", label: "ककनी गाउँपालिका", englishLabel: "Kakani Rural Municipality" },
          { value: "NUWAKOT_KISPANG_MUN", label: "किस्पाङ गाउँपालिका", englishLabel: "Kispang Rural Municipality" },
          { value: "NUWAKOT_TADI_MUN", label: "तादी गाउँपालिका", englishLabel: "Tadi Rural Municipality" },
          { value: "NUWAKOT_TARKESHOWER_MUN", label: "तारकेश्वर गाउँपालिका", englishLabel: "Tarkeshower Rural Municipality" },
          { value: "NUWAKOT_DUPCHESHOWR_MUN", label: "दुप्चेश्वर गाउँपालिका", englishLabel: "Dupcheshowr Rural Municipality" },
          { value: "NUWAKOT_PANCHAKANYA_MUN", label: "पञ्चकन्या गाउँपालिका", englishLabel: "Panchakanya Rural Municipality" },
          { value: "NUWAKOT_LIKHU_MUN", label: "लिखु गाउँपालिका", englishLabel: "Likhu Rural Municipality" },
          { value: "NUWAKOT_MYAGANG_MUN", label: "म्यागङ गाउँपालिका", englishLabel: "Myagang Rural Municipality" },
          { value: "NUWAKOT_SHIWAPURI_MUN", label: "शिवपुरी गाउँपालिका", englishLabel: "Shiwapuri Rural Municipality" },
          { value: "NUWAKOT_SURYAGADI_MUN", label: "सूर्यगढी गाउँपालिका", englishLabel: "Suryagadi Rural Municipality" }
        ]
      },
      {
        value: "rasuwa", label: "रसुवा", englishLabel: "Rasuwa", palikas: [
          { value: "RASUWA_UTTARGAYA_MUN", label: "उत्तरगया गाउँपालिका", englishLabel: "Uttargaya Rural Municipality" },
          { value: "RASUWA_KALIKA_MUN", label: "कालिका गाउँपालिका", englishLabel: "Kalika Rural Municipality" },
          { value: "RASUWA_GOSAIKUNDA_MUN", label: "गोसाईकुण्ड गाउँपालिका", englishLabel: "Gosaikunda Rural Municipality" },
          { value: "RASUWA_NAUKUNDA_MUN", label: "नौकुण्ड गाउँपालिका", englishLabel: "Naukunda Rural Municipality" },
          { value: "RASUWA_AAMACHHODINGMO_MUN", label: "आमाछोदिङमो गाउँपालिका", englishLabel: "Aamachhodingmo Rural Municipality" }
        ]
      },
      {
        value: "dhading", label: "धादिङ", englishLabel: "Dhading", palikas: [
          { value: "DHADING_DHUNBESHI_MUN", label: "धुनीबेंशी नगरपालिका", englishLabel: "Dhunbeshi Municipality" },
          { value: "DHADING_NILAKANTHA_MUN", label: "निलकण्ठ नगरपालिका", englishLabel: "Nilakantha Municipality" },
          { value: "DHADING_KHANIYABAS", label: "खनियाबास गाउँपालिका", englishLabel: " Rural Municipality" },
          { value: "DHADING_GAJURI_MUN", label: "गजुरी गाउँपालिका", englishLabel: "Gajuri Rural Municipality" },
          { value: "DHADING_GALCHHI_MUN", label: "गल्छी गाउँपालिका", englishLabel: "Galchhi Rural Municipality" },
          { value: "DHADING_GANGAJAMUNA_MUN", label: "गङ्गाजमुना गाउँपालिका", englishLabel: "Gangajamuna Rural Municipality" },
          { value: "DHADING_JWALAMUKHI_MUN", label: "ज्वालामूखी गाउँपालिका", englishLabel: "Jwalamukhi Rural Municipality" },
          { value: "DHADING_THAKRE_MUN", label: "थाक्रे गाउँपालिका", englishLabel: "Thakre Rural Municipality" },
          { value: "DHADING_NETRAWATI_DABAJONG_MUN", label: "नेत्रावती डबजोङ गाउँपालिका", englishLabel: "Netrawati Dabajong Rural Municipality" },
          { value: "DHADING_BENIGHAT_RORANG_MUN", label: "बेनीघाट रोराङ्ग गाउँपालिका", englishLabel: "Benighat Rorang Rural Municipality" },
          { value: "DHADING_RUWI_VYALI_MUN", label: "रुवी भ्याली गाउँपालिका", englishLabel: "Ruwi Vyali Rural Municipality" },
          { value: "DHADING_SIDDHALEKH_MUN", label: "सिद्धलेक गाउँपालिका", englishLabel: "Siddhalekh Rural Municipality" },
          { value: "DHADING_TRIPURASUNDARI_MUN", label: "त्रिपुरासुन्दरी गाउँपालिका", englishLabel: "Tripurasundari Rural Municipality" }
        ]
      },
      {
        value: "makawanpur", label: "मकवानपुर", englishLabel: "Makawanpur", palikas: [
          { value: "MAKAWANPUR_HETAUDA_MUN", label: "हेटौडा उपमहानगरपालिका", englishLabel: "Hetauda Sub-Metropolitan City" },
          { value: "MAKAWANPUR_THAHA_MUN", label: "थाहा नगरपालिका", englishLabel: "Thaha Municipality" },
          { value: "MAKAWANPUR_INDRASAROBAR_MUN", label: "इन्द्रसरोबर गाउँपालिका", englishLabel: "Indrasarobar Rural Municipality" },
          { value: "MAKAWANPUR_KAILASH_MUN", label: "कैलाश गाउँपालिका", englishLabel: "Kailash Rural Municipality" },
          { value: "MAKAWANPUR_BAKAIYA_MUN", label: "बकैया गाउँपालिका", englishLabel: "Bakaiya Rural Municipality" },
          { value: "MAKAWANPUR_BAGMATI_MUN", label: "बाग्मति गाउँपालिका", englishLabel: "Bagmati Rural Municipality" },
          { value: "MAKAWANPUR_BHIMFEDI_MUN", label: "भिमफेदी गाउँपालिका", englishLabel: "Bhimfedi Rural Municipality" },
          { value: "MAKAWANPUR_MAKAWANPURGADI_MUN", label: "मकवानपुरगढी गाउँपालिका", englishLabel: "Makawanpurgadi Rural Municipality" },
          { value: "MAKAWANPUR_MANAHARI_MUN", label: "मनहरी गाउँपालिका", englishLabel: "Manahari Rural Municipality" },
          { value: "MAKAWANPUR_RAKSIRANG_MUN", label: "राक्सिराङ्ग गाउँपालिका", englishLabel: "Raksirang Rural Municipality" }
        ]
      },
      {
        value: "chitwan", label: "चितवन", englishLabel: "Chitwan", palikas: [
          { value: "CHITWAN_BHARATPUR_MUN", label: "भरतपुर महानगरपालिका", englishLabel: "Bharatpur Metropolitan City" },
          { value: "CHITWAN_KALIKA_MUN", label: "कालिका नगरपालिका", englishLabel: "Kalika Municipality" },
          { value: "CHITWAN_KHAIRAHANI_MUN", label: "खैरहनी नगरपालिका", englishLabel: "Khairahani Municipality" },
          { value: "CHITWAN_MADI_MUN", label: "माडी नगरपालिका", englishLabel: "Madi Municipality" },
          { value: "CHITWAN_RATNANAGAR_MUN", label: "रत्ननगर नगरपालिका", englishLabel: "Ratnanagar Municipality" },
          { value: "CHITWAN_RAPTI_MUN", label: "राप्ती नगरपालिका", englishLabel: "Rapti Municipality" },
          { value: "CHITWAN_ICHCHHAKAMANA_MUN", label: "इच्छाकामना गाउँपालिका", englishLabel: "Ichchhakamana Rural Municipality" }
        ]
      }
    ]
  },
  {
    value: "GANDAKI_PROVINCE", label: "गण्डकी प्रदेश", englishLabel: "Gandaki Province", districts: [
      {
        value: "gorakha", label: "गोरखा", englishLabel: "Gorakha", palikas: [
          { value: "GORAKHA_GORAKHA_MUN", label: "गोरखा नगरपालिका", englishLabel: "Gorakha Municipality" },
          { value: "GORAKHA_PALUNGTAR_MUN", label: "पालुङटार नगरपालिका", englishLabel: "Palungtar Municipality" },
          { value: "GORAKHA_BARPAK_SULIKOT_MUN", label: "बारपाक सुलिकोट गाउँपालिका", englishLabel: "Barpak Sulikot Rural Municipality" },
          { value: "GORAKHA_SIRANCHOK_MUN", label: "सिरानचोक गाउँपालिका", englishLabel: "Siranchok Rural Municipality" },
          { value: "GORAKHA_AAJIRKOT_MUN", label: "अजिरकोट गाउँपालिका", englishLabel: "Aajirkot Rural Municipality" },
          { value: "GORAKHA_AARUGHAT_MUN", label: "आरूघाट गाउँपालिका", englishLabel: "Aarughat Rural Municipality" },
          { value: "GORAKHA_GANDAKI_MUN", label: "गण्डकी गाउँपालिका", englishLabel: "Gandaki Rural Municipality" },
          { value: "GORAKHA_CHUMANUWRI_MUN", label: "चुमनुव्री गाउँपालिका", englishLabel: "Chumanuwri Rural Municipality" },
          { value: "GORAKHA_DHARCHE_MUN", label: "धार्चे गाउँपालिका", englishLabel: "Dharche Rural Municipality" },
          { value: "GORAKHA_BHIMSENTHAPA_MUN", label: "भिमसेनथापा गाउँपालिका", englishLabel: "Bhimsenthapa Rural Municipality" },
          { value: "GORAKHA_SHAHID_LAKHAN_MUN", label: "शहिद लखन गाउँपालिका", englishLabel: "Shahid Lakhan Rural Municipality" }
        ]
      },
      {
        value: "lamjung", label: "लमजुङ", englishLabel: "Lamjung", palikas: [
          { value: "LAMJUNG_BESISHAHAR_MUN", label: "बेसीशहर नगरपालिका", englishLabel: "Besishahar Municipality" },
          { value: "LAMJUNG_MADDHYANEPAL_MUN", label: "मध्यनेपाल नगरपालिका", englishLabel: "Maddhyanepal Municipality" },
          { value: "LAMJUNG_RAINAS_MUN", label: "राइनास नगरपालिका", englishLabel: "Rainas Municipality" },
          { value: "LAMJUNG_SUNDARBAJAR_MUN", label: "सुन्दरबजार नगरपालिका", englishLabel: "Sundarbajar Municipality" },
          { value: "LAMJUNG_KWHOLASOTHAR_MUN", label: "क्व्होलासोथार गाउँपालिका", englishLabel: "Kwholasothar Rural Municipality" },
          { value: "LAMJUNG_DUDHAPOKHARI_MUN", label: "दूधपोखरी गाउँपालिका", englishLabel: "Dudhapokhari Rural Municipality" },
          { value: "LAMJUNG_DORDI_MUN", label: "दोर्दी गाउँपालिका", englishLabel: "Dordi Rural Municipality" },
          { value: "LAMJUNG_MARSYANGDI_MUN", label: "मर्स्याङदी गाउँपालिका", englishLabel: "Marsyangdi Rural Municipality" }
        ]
      },
      {
        value: "tanahu", label: "तनहुँ", englishLabel: "Tanahu", palikas: [
          { value: "TANAHU_BHANU_MUN", label: "भानु नगरपालिका", englishLabel: "Bhanu Municipality" },
          { value: "TANAHU_BHIMAD_MUN", label: "भिमाद नगरपालिका", englishLabel: "Bhimad Municipality" },
          { value: "TANAHU_BYAS_MUN", label: "व्यास नगरपालिका", englishLabel: "Byas Municipality" },
          { value: "TANAHU_SHUKLAGANDAKI_MUN", label: "शुक्लागण्डकी नगरपालिका", englishLabel: "Shuklagandaki Municipality" },
          { value: "TANAHU_AABUKHAIRAHANI_MUN", label: "आँबुखैरेनी गाउँपालिका", englishLabel: "Aabukhairahani Rural Municipality" },
          { value: "TANAHU_RISING_MUN", label: "ऋषिङ्ग गाउँपालिका", englishLabel: "Rising Rural Municipality" },
          { value: "TANAHU_GHIRING_MUN", label: "घिरिङ गाउँपालिका", englishLabel: "Ghiring Rural Municipality" },
          { value: "TANAHU_DEWAGHAT_MUN", label: "देवघाट गाउँपालिका", englishLabel: "Dewaghat Rural Municipality" },
          { value: "TANAHU_MYAGDE_MUN", label: "म्याग्दे गाउँपालिका", englishLabel: "Myagde Rural Municipality" },
          { value: "TANAHU_WANDIPUR_MUN", label: "वन्दिपुर गाउँपालिका", englishLabel: "Bandipur Rural Municipality" }
        ]
      },
      {
        value: "syangja", label: "स्याङ्जा", englishLabel: "Syangja", palikas: [
          { value: "SYANGJA_GALYANG_MUN", label: "गल्याङ नगरपालिका", englishLabel: "Galyang Municipality" },
          { value: "SYANGJA_CHAPAKOT_MUN", label: "चापाकोट नगरपालिका", englishLabel: "Chapakot Municipality" },
          { value: "SYANGJA_PUTALIBAJAR_MUN", label: "पुतलीबजार नगरपालिका", englishLabel: "Putalibajar Municipality" },
          { value: "SYANGJA_BHIRKOT_MUN", label: "भीरकोट नगरपालिका", englishLabel: "Bhirkot Municipality" },
          { value: "SYANGJA_WALING_MUN", label: "वालिङ नगरपालिका", englishLabel: "Waling Municipality" },
          { value: "SYANGJA_ARJUNCHAUPARI_MUN", label: "अर्जुनचौपारी गाउँपालिका", englishLabel: "Arjunchaupari Rural Municipality" },
          { value: "SYANGJA_AADHIKHOLA_MUN", label: "आँधिखोला गाउँपालिका", englishLabel: "Aadhikhola Rural Municipality" },
          { value: "SYANGJA_KALIGANDAKI_MUN", label: "कालीगण्डकी गाउँपालिका", englishLabel: "Kaligandaki Rural Municipality" },
          { value: "SYANGJA_FEDIKHOLA_MUN", label: "फेदीखोला गाउँपालिका", englishLabel: "Fedikhola Rural Municipality" },
          { value: "SYANGJA_BIRUWA_MUN", label: "बिरुवा गाउँपालिका", englishLabel: "Biruwa Rural Municipality" },
          { value: "SYANGJA_HARINAS_MUN", label: "हरिनास गाउँपालिका", englishLabel: "Harinas Rural Municipality" }
        ]
      },
      {
        value: "kaski", label: "कास्की", englishLabel: "Kaski", palikas: [
          { value: "KASKI_POKHARA_MUN", label: "पोखरा महानगरपालिका", englishLabel: "Pokhara Metropolitan City" },
          { value: "KASKI_ANNAPURNA_MUN", label: "अन्नपूर्ण गाउँपालिका", englishLabel: "Annapurna Rural Municipality" },
          { value: "KASKI_MACHHAPUCHCHHRE_MUN", label: "माछापुच्छ्रे गाउँपालिका", englishLabel: "Machhapuchchhre Rural Municipality" },
          { value: "KASKI_MADI_MUN", label: "मादी गाउँपालिका", englishLabel: "Madi Rural Municipality" },
          { value: "KASKI_RUPA_MUN", label: "रूपा गाउँपालिका", englishLabel: "Rupa Rural Municipality" }
        ]
      },
      {
        value: "manang", label: "मनाङ", englishLabel: "Manang", palikas: [
          { value: "MANANG_CHAME_MUN", label: "चामे गाउँपालिका", englishLabel: "Chame Rural Municipality" },
          { value: "MANANG_NARPA_BHUMI_MUN", label: "नार्पा भूमि गाउँपालिका", englishLabel: "Narpa Bhumi Rural Municipality" },
          { value: "MANANG_NASO_MUN", label: "नासोँ गाउँपालिका", englishLabel: "Naso Rural Municipality" },
          { value: "MANANG_MANANG_NGISYANG_MUN", label: "मनाङ ङिस्याङ गाउँपालिका", englishLabel: "Manang ngisyang Rural Municipality" }
        ]
      },
      {
        value: "mustang", label: "मुस्ताङ", englishLabel: "Mustang", palikas: [
          { value: "MUSTANG_GHARPAJHONG_MUN", label: "घरपझोङ गाउँपालिका", englishLabel: "Gharpajhong Rural Municipality" },
          { value: "MUSTANG_THASANG_MUN", label: "थासाङ गाउँपालिका", englishLabel: "Thasang Rural Municipality" },
          { value: "MUSTANG_LOGHEKAR_DAMODARKUNDA_MUN", label: "लो-घेकर दामोदरकुण्ड गाउँपालिका", englishLabel: "Loghekar Damodarkunda Rural Municipality" },
          { value: "MUSTANG_LOMANTHANG_MUN", label: "लोमन्थाङ गाउँपालिका", englishLabel: "Lomanthang Rural Municipality" },
          { value: "MUSTANG_WARAGUNG_MUN", label: "वारागुङ मुक्तिक्षेत्र गाउँपालिका", englishLabel: "Baragung Rural Municipality" }
        ]
      },
      {
        value: "myagdi", label: "म्याग्दी", englishLabel: "Myagdi", palikas: [
          { value: "MYAGDI_BENI_MUN", label: "बेनी नगरपालिका", englishLabel: "Beni Municipality" },
          { value: "MYAGDI_ANNAPURNA_MUN", label: "अन्नपुर्ण गाउँपालिका", englishLabel: "Annapurna Rural Municipality" },
          { value: "MYAGDI_DHAWALAGIRI_MUN", label: "धवलागिरी गाउँपालिका", englishLabel: "Dhawalagiri Rural Municipality" },
          { value: "MYAGDI_MANGALA_MUN", label: "मंगला गाउँपालिका", englishLabel: "Mangala Rural Municipality" },
          { value: "MYAGDI_MALIKA_MUN", label: "मालिका गाउँपालिका", englishLabel: "Malika Rural Municipality" },
          { value: "MYAGDI_RAGHUGANGA_MUN", label: "रघुगंगा गाउँपालिका", englishLabel: "Raghuganga Rural Municipality" }
        ]
      },
      {
        value: "parbat", label: "पर्वत", englishLabel: "Parbat", palikas: [
          { value: "PARBAT_KUSHMA_MUN", label: "कुश्मा नगरपालिका", englishLabel: "Kushma Municipality" },
          { value: "PARBAT_FALEWAS_MUN", label: "फलेवास नगरपालिका", englishLabel: "Falewas Municipality" },
          { value: "PARBAT_JALJALA_MUN", label: "जलजला गाउँपालिका", englishLabel: "Jaljala Rural Municipality" },
          { value: "PARBAT_PAIYU_MUN", label: "पैयूं गाउँपालिका", englishLabel: "Paiyu Rural Municipality" },
          { value: "PARBAT_MAHASHILA_MUN", label: "महाशिला गाउँपालिका", englishLabel: "Mahashila Rural Municipality" },
          { value: "PARBAT_MODI_MUN", label: "मोदी गाउँपालिका", englishLabel: "Modi Rural Municipality" },
          { value: "PARBAT_WIHADI_MUN", label: "विहादी गाउँपालिका", englishLabel: "Wihadi Rural Municipality" }
        ]
      },
      {
        value: "baglung", label: "बागलुङ", englishLabel: "Baglung", palikas: [
          { value: "BAGLUNG_BAGLUNG_MUN", label: "बागलुङ नगरपालिका", englishLabel: "Baglung Municipality" },
          { value: "BAGLUNG_GALKOT_MUN", label: "गल्कोट नगरपालिका", englishLabel: "Galkot Municipality" },
          { value: "BAGLUNG_JAIMUNI_MUN", label: "जैमिनी नगरपालिका", englishLabel: "Jaimuni Municipality" },
          { value: "BAGLUNG_DHORPATAN_MUN", label: "ढोरपाटन नगरपालिका", englishLabel: "Dhorpatan Municipality" },
          { value: "BAGLUNG_WARENG_MUN", label: "वरेङ गाउँपालिका", englishLabel: "Bareng Rural Municipality" },
          { value: "BAGLUNG_KATHEKHOLA_MUN", label: "काठेखोला गाउँपालिका", englishLabel: "Kathekhola Rural Municipality" },
          { value: "BAGLUNG_TAMANKHOLA_MUN", label: "तमानखोला गाउँपालिका", englishLabel: "Tamankhola Rural Municipality" },
          { value: "BAGLUNG_TARAKHOLA_MUN", label: "ताराखोला गाउँपालिका", englishLabel: "Tarakhola Rural Municipality" },
          { value: "BAGLUNG_NISIKHOLA_MUN", label: "निसीखोला गाउँपालिका", englishLabel: "Nisikhola Rural Municipality" },
          { value: "BAGLUNG_WADIGAD_MUN", label: "वडिगाड गाउँपालिका", englishLabel: "Badigad Rural Municipality" }
        ]
      },
      {
        value: "nawalparasiSustaPurwa", label: "नवलपरासी (बर्दघाट सुस्ता पूर्व)", englishLabel: "Nawalparasi (Bardaghat Susta Purwa)", palikas: [
          { value: "NAWALPARASI_SUSTA_PURWA_KAWASOTI_MUN", label: "कावासोती नगरपालिका", englishLabel: "Susta Purwa Kawasoti Municipality" },
          { value: "NAWALPARASI_SUSTA_PURWA_GAIDAKOT_MUN", label: "गैडाकोट नगरपालिका", englishLabel: "Susta Purwa Gaidakot Municipality" },
          { value: "NAWALPARASI_SUSTA_PURWA_DEWACHULI_MUN", label: "देवचुली नगरपालिका", englishLabel: "Susta Purwa Dewachuli Municipality" },
          { value: "NAWALPARASI_SUSTA_PURWA_MADHYAWINDU_MUN", label: "मध्यविन्दु नगरपालिका", englishLabel: "Susta Purwa Madhyawindu Municipality" },
          { value: "NAWALPARASI_SUSTA_PURWA_BAUDIKALI_MUN", label: "बौदीकाली गाउँपालिका", englishLabel: "Susta Purwa Baudikali Rural Municipality" },
          { value: "NAWALPARASI_SUSTA_PURWABULINGTAR_MUN", label: "बुलिङटार गाउँपालिका", englishLabel: "Susta Purwa Bulingtar Rural Municipality" },
          { value: "NAWALPARASI_SUSTA_PURWA_WINAYI_MUN", label: "विनयी त्रिवेणी गाउँपालिका", englishLabel: "Susta Purwa Binayi Rural Municipality" },
          { value: "NAWALPARASI_SUSTA_PURWA_HUPSEKOT_MUN", label: "हुप्सेकोट गाउँपालिका", englishLabel: "Susta Purwa Hupsekot Rural Municipality" }
        ]
      }
    ]
  },
  {
    value: "PROVINCE_5", label: "लुम्बिनी प्रदेश", englishLabel: "Lumbini Province", districts: [
      {
        value: "gulmi", label: "गुल्मी", englishLabel: "Gulmi", palikas: [
          { value: "GULMI_MUSIKOT_MUN", label: "मुसिकोट नगरपालिका", englishLabel: "Musikot Municipality" },
          { value: "GULMI_RESUNGA_MUN", label: "रेसुङ्गा नगरपालिका", englishLabel: "Resunga Municipality" },
          { value: "GULMI_ISMA_MUN", label: "ईस्मा गाउँपालिका", englishLabel: "Isma Rural Municipality" },
          { value: "GULMI_KALIGANDAKI_MUN", label: "कालीगण्डकी गाउँपालिका", englishLabel: "Kaligandaki Rural Municipality" },
          { value: "GULMI_GULMI_DARBAR_MUN", label: "गुल्मी दरबार गाउँपालिका", englishLabel: "Gulmi Darbar Rural Municipality" },
          { value: "GULMI_SATYAWATI_MUN", label: "सत्यवती गाउँपालिका", englishLabel: "Satyawati Rural Municipality" },
          { value: "GULMI_CHANDRAKOT_MUN", label: "चन्द्रकोट गाउँपालिका", englishLabel: "Chandrakot Rural Municipality" },
          { value: "GULMI_RURUCHHETRA_MUN", label: "रुरुक्षेत्र गाउँपालिका", englishLabel: "Ruruchhetra Rural Municipality" },
          { value: "GULMI_CHHATRAKOT_MUN", label: "छत्रकोट गाउँपालिका", englishLabel: "Chhatrakot Rural Municipality" },
          { value: "GULMI_DHURKOT_MUN", label: "धुर्कोट गाउँपालिका", englishLabel: "Dhurkot Rural Municipality" },
          { value: "GULMI_MADANE_MUN", label: "मदाने गाउँपालिका", englishLabel: "Madane Rural Municipality" },
          { value: "GULMI_MALIKA_MUN", label: "मालिका गाउँपालिका", englishLabel: "Malika Rural Municipality" }
        ]
      },
      {
        value: "palpa", label: "पाल्पा", englishLabel: "Palpa", palikas: [
          { value: "PALPA_RAMPUR_MUN", label: "रामपुर नगरपालिका", englishLabel: "Rampur Municipality" },
          { value: "PALPA_TANSEN_MUN", label: "तानसेन नगरपालिका", englishLabel: "Tansen Municipality" },
          { value: "PALPA_NISDI_MUN", label: "निस्दी गाउँपालिका", englishLabel: "Nisdi Rural Municipality" },
          { value: "PALPA_PURWAKHOLA_MUN", label: "पूर्वखोला गाउँपालिका", englishLabel: "Purwakhola Rural Municipality" },
          { value: "PALPA_RAMBHA_MUN", label: "रम्भा गाउँपालिका", englishLabel: "Rambha Rural Municipality" },
          { value: "PALPA_MATHAGADI_MUN", label: "माथागढी गाउँपालिका", englishLabel: "Mathagadi Rural Municipality" },
          { value: "PALPA_TINAU_MUN", label: "तिनाउ गाउँपालिका", englishLabel: "Tinau Rural Municipality" },
          { value: "PALPA_BAGANASKALI_MUN", label: "बगनासकाली गाउँपालिका", englishLabel: "Baganaskali Rural Municipality" },
          { value: "PALPA_RIBDIKOT_MUN", label: "रिब्दिकोट गाउँपालिका", englishLabel: "Ribdikot Rural Municipality" },
          { value: "PALPA_RAINADEWI_CHHAHARA_MUN", label: "रैनादेवी छहरा गाउँपालिका", englishLabel: "Rainadewi Chhahara Rural Municipality" }
        ]
      },
      {
        value: "rupandehi", label: "रुपन्देही", englishLabel: "Rupandehi", palikas: [
          { value: "RUPANDEHI_BUTWAL_MUN", label: "बुटवल उपमहानगरपालिका", englishLabel: "Butwal Sub-Metropolitan City" },
          { value: "RUPANDEHI_DEWADAHA_MUN", label: "देवदह नगरपालिका", englishLabel: "Dewadaha Municipality" },
          { value: "RUPANDEHI_LUMBINI_SANSKRITIK_MUN", label: "लुम्बिनी सांस्कृतिक नगरपालिका", englishLabel: "Lumbini Sanskritik Municipality" },
          { value: "RUPANDEHI_SAINAMAINA_MUN", label: "सैनामैना नगरपालिका", englishLabel: "Sainamaina Municipality" },
          { value: "RUPANDEHI_SIDDARTHANAGAR_MUN", label: "सिद्धार्थनगर नगरपालिका", englishLabel: "Siddarthanagar Municipality" },
          { value: "RUPANDEHI_TILOTTAMA_MUN", label: "तिलोत्तमा नगरपालिका", englishLabel: "Tilottama Municipality" },
          { value: "RUPANDEHI_GAIDAHAWA_MUN", label: "गैडहवा गाउँपालिका", englishLabel: "Gaidahawa Rural Municipality" },
          { value: "RUPANDEHI_KANCHAN_MUN", label: "कन्चन गाउँपालिका", englishLabel: "Kanchan Rural Municipality" },
          { value: "RUPANDEHI_KOTAHIMAI_MUN", label: "कोटहीमाई गाउँपालिका", englishLabel: "Kotahimai Rural Municipality" },
          { value: "RUPANDEHI_MARCHAWARI_MUN", label: "मर्चवारी गाउँपालिका", englishLabel: "Marchawari Rural Municipality" },
          { value: "RUPANDEHI_MAYADEWI_MUN", label: "मायादेवी गाउँपालिका", englishLabel: "Mayadewi Rural Municipality" },
          { value: "RUPANDEHI_OMASATIYA_MUN", label: "ओमसतिया गाउँपालिका", englishLabel: "Omasatiya Rural Municipality" },
          { value: "RUPANDEHI_ROHINI_MUN", label: "रोहिणी गाउँपालिका", englishLabel: "Rohini Rural Municipality" },
          { value: "RUPANDEHI_SAMMARIMAI_MUN", label: "सम्मरीमाई गाउँपालिका", englishLabel: "Sammarimai Rural Municipality" },
          { value: "RUPANDEHI_SIYARI_MUN", label: "सियारी गाउँपालिका", englishLabel: "Siyari Rural Municipality" },
          { value: "RUPANDEHI_SHUDDHODHAN_MUN", label: "शुद्धोधन गाउँपालिका", englishLabel: "Shuddhodhan Rural Municipality" }
        ]
      },
      {
        value: "kapilwasthu", label: "कपिलवस्तु", englishLabel: "Kapilwasthu", palikas: [
          { value: "KAPILWASTHU_KAPILWASTHU_MUN", label: "कपिलवस्तु नगरपालिका", englishLabel: "Kapilwasthu Municipality" },
          { value: "KAPILWASTHU_BUDDHABHUMI_MUN", label: "बुद्धभुमी नगरपालिका", englishLabel: "Buddhabhumi Municipality" },
          { value: "KAPILWASTHU_SHIWARAJ_MUN", label: "शिवराज नगरपालिका", englishLabel: "Shiwaraj Municipality" },
          { value: "KAPILWASTHU_MAHARAJGANG_MUN", label: "महाराजगंज नगरपालिका", englishLabel: "Maharajgang Municipality" },
          { value: "KAPILWASTHU_KRISHNANAGAR_MUN", label: "कृष्णनगर नगरपालिका", englishLabel: "Krishnanagar Municipality" },
          { value: "KAPILWASTHU_BANAGANGA_MUN", label: "बाणगंगा नगरपालिका", englishLabel: "Banaganga Municipality" },
          { value: "KAPILWASTHU_MAYADEWI_MUN", label: "मायादेवी गाउँपालिका", englishLabel: "Mayadewi Rural Municipality" },
          { value: "KAPILWASTHU_YASODHARA_MUN", label: "यसोधरा गाउँपालिका", englishLabel: "Yasodhara Rural Municipality" },
          { value: "KAPILWASTHU_SUDDHODHAN", label: "सुद्धोधन गाउँपालिका", englishLabel: " Rural Municipality" },
          { value: "KAPILWASTHU_BIJAYANAGAR_MUN", label: "विजयनगर गाउँपालिका", englishLabel: "Bijayanagar Rural Municipality" }
        ]
      },
      {
        value: "arghakhachi", label: "अर्घाखाँची", englishLabel: "Arghakhachi", palikas: [
          { value: "ARGHAKHACHI_SANDHIKHARKA_MUN", label: "सन्धिखर्क नगरपालिका", englishLabel: "Sandhikharka Municipality" },
          { value: "ARGHAKHACHI_SHITAGANGA_MUN", label: "शितगंगा नगरपालिका", englishLabel: "Shitaganga Municipality" },
          { value: "ARGHAKHACHI_BHUMIKASTHAN_MUN", label: "भूमिकास्थान नगरपालिका", englishLabel: "Bhumikasthan Municipality" },
          { value: "ARGHAKHACHI_CHHATRADEWA_MUN", label: "छत्रदेव गाउँपालिका", englishLabel: "Chhatradewa Rural Municipality" },
          { value: "ARGHAKHACHI_PANINI_MUN", label: "पाणिनी गाउँपालिका", englishLabel: "Panini Rural Municipality" },
          { value: "ARGHAKHACHI_MALARANI_MUN", label: "मालारानी गाउँपालिका", englishLabel: "Malarani Rural Municipality" }
        ]
      },
      {
        value: "pyuthan", label: "प्युठान", englishLabel: "Pyuthan", palikas: [
          { value: "PYUTHAN_PYUTHAN_MUN", label: "प्यूठान नगरपालिका", englishLabel: "Pyuthan Municipality" },
          { value: "PYUTHAN_SWARGADWARI_MUN", label: "स्वर्गद्वारी नगरपालिका", englishLabel: "Swargadwari Municipality" },
          { value: "PYUTHAN_GAUMUKHI_MUN", label: "गौमुखी गाउँपालिका", englishLabel: "Gaumukhi Rural Municipality" },
          { value: "PYUTHAN_MANDAWI_MUN", label: "माण्डवी गाउँपालिका", englishLabel: "Mandawi Rural Municipality" },
          { value: "PYUTHAN_SARUMARANI_MUN", label: "सरुमारानी गाउँपालिका", englishLabel: "Sarumarani Rural Municipality" },
          { value: "PYUTHAN_MALLARANI_MUN", label: "मल्लरानी गाउँपालिका", englishLabel: "Mallarani Rural Municipality" },
          { value: "PYUTHAN_NAUWAHINI_MUN", label: "नौवहिनी गाउँपालिका", englishLabel: "Nauwahini Rural Municipality" },
          { value: "PYUTHAN_JHIMRUK_MUN", label: "झिमरुक गाउँपालिका", englishLabel: "Jhimruk Rural Municipality" },
          { value: "PYUTHAN_YERAWATI_MUN", label: "ऐरावती गाउँपालिका", englishLabel: "Yerawati Rural Municipality" }
        ]
      },
      {
        value: "rolpa", label: "रोल्पा", englishLabel: "Rolpa", palikas: [
          { value: "ROLPA_ROLPA_MUN", label: "रोल्पा नगरपालिका", englishLabel: "Rolpa Municipality" },
          { value: "ROLPA_TRIWENI_MUN", label: "त्रिवेणी गाउँपालिका", englishLabel: "Triweni Rural Municipality" },
          { value: "ROLPA_PARIWARTAN_MUN", label: "परिवर्तन गाउँपालिका", englishLabel: "Pariwartan Rural Municipality" },
          { value: "ROLPA_MADI_MUN", label: "माडी गाउँपालिका", englishLabel: "Madi Rural Municipality" },
          { value: "ROLPA_RUNTIGADI_MUN", label: "रुन्टीगढी गाउँपालिका", englishLabel: "Runtigadi Rural Municipality" },
          { value: "ROLPA_LUNGRI_MUN", label: "लुङग्री गाउँपालिका", englishLabel: "Lungri Rural Municipality" },
          { value: "ROLPA_GANGADEWA_MUN", label: "गंगादेव गाउँपालिका", englishLabel: "Gangadewa Rural Municipality" },
          { value: "ROLPA_SUNCHHAHARI_MUN", label: "सुनछहरी गाउँपालिका", englishLabel: "Sunchhahari Rural Municipality" },
          { value: "ROLPA_SUNIL_SMRITI_MUN", label: "सुनिल स्मृति गाउँपालिका", englishLabel: "Sunil Smriti Rural Municipality" },
          { value: "ROLPA_THAWANG_MUN", label: "थवाङ गाउँपालिका", englishLabel: "Thawang Rural Municipality" }
        ]
      },
      {
        value: "dang", label: "दाङ", englishLabel: "Dang", palikas: [
          { value: "DANG_TULSIPUR_MUN", label: "तुल्सीपुर उपमहानगरपालिका", englishLabel: "Tulsipur Sub-Metropolitan City" },
          { value: "DANG_GHORAHI_MUN", label: "घोराही उपमहानगरपालिका", englishLabel: "Ghorahi Sub-Metropolitan City" },
          { value: "DANG_LAMAHI_MUN", label: "लमही नगरपालिका", englishLabel: "Lamahi Municipality" },
          { value: "DANG_BANGALACHULI_MUN", label: "बंगलाचुली गाउँपालिका", englishLabel: "Bangalachuli Rural Municipality" },
          { value: "DANG_DANGISHARAN_MUN", label: "दंगीशरण गाउँपालिका", englishLabel: "Dangisharan Rural Municipality" },
          { value: "DANG_GADAWA_MUN", label: "गढवा गाउँपालिका", englishLabel: "Gadawa Rural Municipality" },
          { value: "DANG_RAJPUR_MUN", label: "राजपुर गाउँपालिका", englishLabel: "Rajpur Rural Municipality" },
          { value: "DANG_RAPTI_MUN", label: "राप्ती गाउँपालिका", englishLabel: "Rapti Rural Municipality" },
          { value: "DANG_SHANTINAGAR_MUN", label: "शान्तिनगर गाउँपालिका", englishLabel: "Shantinagar Rural Municipality" },
          { value: "DANG_BABAI_MUN", label: "बबई गाउँपालिका", englishLabel: "Babai Rural Municipality" }
        ]
      },
      {
        value: "bake", label: "बाँके", englishLabel: "Banke", palikas: [
          { value: "BAKE_NEPALGANJ_MUN", label: "नेपालगंज उपमहानगरपालिका", englishLabel: "Nepalganj Sub-Metropolitan City" },
          { value: "BAKE_KOHALAPUR_MUN", label: "कोहलपुर नगरपालिका", englishLabel: "Kohalapur Municipality" },
          { value: "BAKE_NARAINAPUR_MUN", label: "नरैनापुर गाउँपालिका", englishLabel: "Narainapur Rural Municipality" },
          { value: "BAKE_RAPTI_SONARI_MUN", label: "राप्ती सोनारी गाउँपालिका", englishLabel: "Rapti Sonari Rural Municipality" },
          { value: "BAKE_BAIJANATH_MUN", label: "बैजनाथ गाउँपालिका", englishLabel: "Baijanath Rural Municipality" },
          { value: "BAKE_KHAJURA_MUN", label: "खजुरा गाउँपालिका", englishLabel: "Khajura Rural Municipality" },
          { value: "BAKE_DADUWA_MUN", label: "डुडुवा गाउँपालिका", englishLabel: "Daduwa Rural Municipality" },
          { value: "BAKE_JANAKI_MUN", label: "जानकी गाउँपालिका", englishLabel: "Janaki Rural Municipality" }
        ]
      },
      {
        value: "bardiya", label: "बर्दिया", englishLabel: "Bardiya", palikas: [
          { value: "BARDIYA_GULARIYA_MUN", label: "गुलरिया नगरपालिका", englishLabel: "Gulariya Municipality" },
          { value: "BARDIYA_MADHUWAN_MUN", label: "मधुवन नगरपालिका", englishLabel: "Madhuwan Municipality" },
          { value: "BARDIYA_RAJAPUR_MUN", label: "राजापुर नगरपालिका", englishLabel: "Rajapur Municipality" },
          { value: "BARDIYA_THAKURBABA_MUN", label: "ठाकुरबाबा नगरपालिका", englishLabel: "Thakurbaba Municipality" },
          { value: "BARDIYA_BASAGADI_MUN", label: "बाँसगढी नगरपालिका", englishLabel: "Basagadi Municipality" },
          { value: "BARDIYA_BARBARDIYA_MUN", label: "बारबर्दिया नगरपालिका", englishLabel: "Barbardiya Municipality" },
          { value: "BARDIYA_BADAIYATAL_MUN", label: "बढैयाताल गाउँपालिका", englishLabel: "Badaiyatal Rural Municipality" },
          { value: "BARDIYA_GERUWA_MUN", label: "गेरुवा गाउँपालिका", englishLabel: "Geruwa Rural Municipality" }
        ]
      },
      {
        value: "nawalparasiSustaPaschchim", label: "नवलपरासी (बर्दघाट सुस्ता पश्चिम)", englishLabel: "Nawalparasi (Bardaghat Susta Paschim)", palikas: [
          { value: "NAWALPARASI_SUSTA_PASCHCHIM_BARDAGHAT_MUN", label: "बर्दघाट नगरपालिका", englishLabel: "Susta Paschchim Bardaghat Municipality" },
          { value: "NAWALPARASI_SUSTA_PASCHCHIM_RAMGRAM_MUN", label: "रामग्राम नगरपालिका", englishLabel: "Susta Paschchim Ramgram Municipality" },
          { value: "NAWALPARASI_SUSTA_PASCHCHIM_SUNAWAL_MUN", label: "सुनवल नगरपालिका", englishLabel: "Susta Paschchim Sunawal Municipality" },
          { value: "NAWALPARASI_SUSTA_PASCHCHIM_SUSTA_MUN", label: "सुस्ता गाउँपालिका", englishLabel: "Susta Paschchim Susta Rural Municipality" },
          { value: "NAWALPARASI_SUSTA_PASCHCHIM_PALHINANDAN_MUN", label: "पाल्हीनन्दन गाउँपालिका", englishLabel: "Susta Paschchim palhinandan Rural Municipality" },
          { value: "NAWALPARASI_SUSTA_PASCHCHIM_PRATAPPUR_MUN", label: "प्रतापपुर गाउँपालिका", englishLabel: "Susta Paschchim Pratappur Rural Municipality" },
          { value: "NAWALPARASI_SUSTA_PASCHCHIM_SARAWAL_MUN", label: "सरावल गाउँपालिका", englishLabel: "Susta Paschchim Sarawal Rural Municipality" }
        ]
      },
      {
        value: "rukumPurwa", label: "रुकुम (पूर्वी भाग)", englishLabel: "Rukum (Eastern Part)", palikas: [
          { value: "RUKUM_PURWA_PUTHA_UTTARGANGA_MUN", label: "पुथा उत्तरगंगा गाउँपालिका", englishLabel: "Purwa Putha Uttarganga Rural Municipality" },
          { value: "RUKUM_PURWA_BHUME_MUN", label: "भूमे गाउँपालिका", englishLabel: "Purwa Bhume Rural Municipality" },
          { value: "RUKUM_PURWA_SISNE_MUN", label: "सिस्ने गाउँपालिका", englishLabel: "Purwa Sisne Rural Municipality" }
        ]
      }
    ]
  },
  {
    value: "KARNALI_PROVINCE", label: "कर्णाली प्रदेश", englishLabel: "Karnali Province", districts: [
      {
        value: "salyan", label: "सल्यान", englishLabel: "Salyan", palikas: [
          { value: "SALYAN_SHARADA_MUN", label: "शारदा नगरपालिका", englishLabel: "Sharada Municipality" },
          { value: "SALYAN_BAGCHAUR_MUN", label: "बागचौर नगरपालिका", englishLabel: "Bagchaur Municipality" },
          { value: "SALYAN_BANGAD_MUN", label: "बनगाड कुपिण्डे नगरपालिका", englishLabel: "Bangad Municipality" },
          { value: "SALYAN_KALIMATI_MUN", label: "कालिमाटी गाउँपालिका", englishLabel: "Kalimati Rural Municipality" },
          { value: "SALYAN_TRIBENI_MUN", label: "त्रिवेणी गाउँपालिका", englishLabel: "Tribeni Rural Municipality" },
          { value: "SALYAN_KAPURKOT_MUN", label: "कपुरकोट गाउँपालिका", englishLabel: "Kapurkot Rural Municipality" },
          { value: "SALYAN_CHHATRESHOWRI_MUN", label: "छत्रेश्वरी गाउँपालिका", englishLabel: "Chhatreshowri Rural Municipality" },
          { value: "SALYAN_SIDDHA_KUMAKH_MUN", label: "सिद्ध कुमाख गाउँपालिका", englishLabel: "Siddha Kumakh Rural Municipality" },
          { value: "SALYAN_DARMA_MUN", label: "दर्मा गाउँपालिका", englishLabel: "Darma Rural Municipality" },
          { value: "SALYAN_KUMAKH_MUN", label: "कुमाख गाउँपालिका", englishLabel: "Kumakh Rural Municipality" }
        ]
      },
      {
        value: "surkhet", label: "सुर्खेत", englishLabel: "Surkhet", palikas: [
          { value: "SURKHET_BIRENDRANAGAR_MUN", label: "बीरेन्द्रनगर नगरपालिका", englishLabel: "Birendranagar Municipality" },
          { value: "SURKHET_BHERIGANGA_MUN", label: "भेरीगंगा नगरपालिका", englishLabel: "Bheriganga Municipality" },
          { value: "SURKHET_GURBHAKOT_MUN", label: "गुर्भाकोट नगरपालिका", englishLabel: "Gurbhakot Municipality" },
          { value: "SURKHET_PANCHAPURI_MUN", label: "पञ्चपुरी नगरपालिका", englishLabel: "Panchapuri Municipality" },
          { value: "SURKHET_LEKWESHI_MUN", label: "लेकवेशी नगरपालिका", englishLabel: "Lekweshi Municipality" },
          { value: "SURKHET_CHAUKUNE_MUN", label: "चौकुने गाउँपालिका", englishLabel: "Chaukune Rural Municipality" },
          { value: "SURKHET_BARAHATAL_MUN", label: "बराहताल गाउँपालिका", englishLabel: "Barahatal Rural Municipality" },
          { value: "SURKHET_CHINGAD_MUN", label: "चिङ्गाड गाउँपालिका", englishLabel: "Chingad Rural Municipality" },
          { value: "SURKHET_SIMTA_MUN", label: "सिम्ता गाउँपालिका", englishLabel: "Simta Rural Municipality" }
        ]
      },
      {
        value: "dailekh", label: "दैलेख", englishLabel: "Dailekh", palikas: [
          { value: "DAILEKH_NARAYAN_MUN", label: "नारायण नगरपालिका", englishLabel: "Narayan Municipality" },
          { value: "DAILEKH_DULLU_MUN", label: "दुल्लु नगरपालिका", englishLabel: "Dullu Municipality" },
          { value: "DAILEKH_CHAMUNDA_WINDRASAINI_MUN", label: "चामुण्डा विन्द्रासैनी नगरपालिका", englishLabel: "Chamunda Windrasaini Municipality" },
          { value: "DAILEKH_AATHBIS_MUN", label: "आठबीस नगरपालिका", englishLabel: "Aathbis Municipality" },
          { value: "DAILEKH_BHAGAWATIMAI_MUN", label: "भगवतीमाई गाउँपालिका", englishLabel: "Bhagawatimai Rural Municipality" },
          { value: "DAILEKH_GURAS_MUN", label: "गुराँस गाउँपालिका", englishLabel: "Guras Rural Municipality" },
          { value: "DAILEKH_DUGESHOWER_MUN", label: "डुंगेश्वर गाउँपालिका", englishLabel: "Dugeshower Rural Municipality" },
          { value: "DAILEKH_NAUMULE_MUN", label: "नौमुले गाउँपालिका", englishLabel: "Naumule Rural Municipality" },
          { value: "DAILEKH_MAHAWU_MUN", label: "महावु गाउँपालिका", englishLabel: "Mahawu Rural Municipality" },
          { value: "DAILEKH_BHAIRAWI_MUN", label: "भैरवी गाउँपालिका", englishLabel: "Bhairawi Rural Municipality" },
          { value: "DAILEKH_THATIKADH_MUN", label: "ठाँटीकाँध गाउँपालिका", englishLabel: "Thatikadh Rural Municipality" }
        ]
      },
      {
        value: "jaajarkot", label: "जाजरकोट", englishLabel: "Jajarkot", palikas: [
          { value: "JAJARKOT_BHERI_MUN", label: "भेरी नगरपालिका", englishLabel: "Bheri Municipality" },
          { value: "JAJARKOT_CHHEDAGAD_MUN", label: "छेडागाड नगरपालिका", englishLabel: "Chhedagad Municipality" },
          { value: "JAJARKOT_NALAGAD_MUN", label: "नलगाड नगरपालिका", englishLabel: "Nalagad Municipality" },
          { value: "JAJARKOT_BAREKOT_MUN", label: "बारेकोट गाउँपालिका", englishLabel: "Barekot Rural Municipality" },
          { value: "JAJARKOT_KUSE_MUN", label: "कुसे गाउँपालिका", englishLabel: "Kuse Rural Municipality" },
          { value: "JAJARKOT_JUNICHADE_MUN", label: "जुनीचाँदे गाउँपालिका", englishLabel: "Junichade Rural Municipality" },
          { value: "JAJARKOT_SHIWALAYA_MUN", label: "शिवालय गाउँपालिका", englishLabel: "Shiwalaya Rural Municipality" }
        ]
      },
      {
        value: "dolpa", label: "डोल्पा", englishLabel: "Dolpa", palikas: [
          { value: "DOLPA_THULO_BHERI_MUN", label: "ठूली भेरी नगरपालिका", englishLabel: "Thulo Bheri Municipality" },
          { value: "DOLPA_TRIPURASUNDARI_MUN", label: "त्रिपुरासुन्दरी नगरपालिका", englishLabel: "Tripurasundari Municipality" },
          { value: "DOLPA_DOLPO_BUDDHA_MUN", label: "डोल्पो बुद्ध गाउँपालिका", englishLabel: "Dolpo Buddha Rural Municipality" },
          { value: "DOLPA_SE_FOKSUNDO_MUN", label: "शे फोक्सुन्डो गाउँपालिका", englishLabel: "Se Foksundo Rural Municipality" },
          { value: "DOLPA_JAGADULLA_MUN", label: "जगदुल्ला गाउँपालिका", englishLabel: "Jagadulla Rural Municipality" },
          { value: "DOLPA_MUDKECHULA_MUN", label: "मुड्केचुला गाउँपालिका", englishLabel: "Mudkechula Rural Municipality" },
          { value: "DOLPA_KAIKE_MUN", label: "काईके गाउँपालिका", englishLabel: "Kaike Rural Municipality" },
          { value: "DOLPA_CHHARKA_TANGSONG_MUN", label: "छार्का ताङसोङ गाउँपालिका", englishLabel: "Chharka Tangsong Rural Municipality" }
        ]
      },
      {
        value: "jumla", label: "जुम्ला", englishLabel: "Jumla", palikas: [
          { value: "JUMLA_CHANDANNATH_MUN", label: "चन्दननाथ नगरपालिका", englishLabel: "Chandannath Municipality" },
          { value: "JUMLA_KANAKASUNDARI_MUN", label: "कनकासुन्दरी गाउँपालिका", englishLabel: "Kanakasundari Rural Municipality" },
          { value: "JUMLA_SINJA_MUN", label: "सिंजा गाउँपालिका", englishLabel: "Sinja Rural Municipality" },
          { value: "JUMLA_HIMA_MUN", label: "हिमा गाउँपालिका", englishLabel: "Hima Rural Municipality" },
          { value: "JUMLA_TILA_MUN", label: "तिला गाउँपालिका", englishLabel: "Tila Rural Municipality" },
          { value: "JUMLA_GUTHICHAUR_MUN", label: "गुठिचौर गाउँपालिका", englishLabel: "Guthichaur Rural Municipality" },
          { value: "JUMLA_TATOPANI_MUN", label: "तातोपानी गाउँपालिका", englishLabel: "Tatopani Rural Municipality" },
          { value: "JUMLA_PATARASI_MUN", label: "पातारासी गाउँपालिका", englishLabel: "Patarasi Rural Municipality" }
        ]
      },
      {
        value: "kalikot", label: "कालिकोट", englishLabel: "Kalikot", palikas: [
          { value: "KALIKOT_KHADACHAKRA_MUN", label: "खाँडाचक्र नगरपालिका", englishLabel: "Khadachakra Municipality" },
          { value: "KALIKOT_RASKOT_MUN", label: "रास्कोट नगरपालिका", englishLabel: "Raskot Municipality" },
          { value: "KALIKOT_TILAGUFA_MUN", label: "तिलागुफा नगरपालिका", englishLabel: "Tilagufa Municipality" },
          { value: "KALIKOT_PACHALJHARANA_MUN", label: "पचालझरना गाउँपालिका", englishLabel: "Pachaljharana Rural Municipality" },
          { value: "KALIKOT_SANNI_TRIWENI_MUN", label: "सान्नी त्रिवेणी गाउँपालिका", englishLabel: "Sanni Tribeni Rural Municipality" },
          { value: "KALIKOT_NARAHARINATH_MUN", label: "नरहरिनाथ गाउँपालिका", englishLabel: "Naraharinath Rural Municipality" },
          { value: "KALIKOT_SHUBHA_KALIKA_MUN", label: "शुभ कालीका गाउँपालिका", englishLabel: "Shubha Kalika Rural Municipality" },
          { value: "KALIKOT_MAHAWAI_MUN", label: "महावै गाउँपालिका", englishLabel: "Mahawai Rural Municipality" },
          { value: "KALIKOT_PALATA_MUN", label: "पलाता गाउँपालिका", englishLabel: "Palata Rural Municipality" }
        ]
      },
      {
        value: "mugu", label: "मुगु", englishLabel: "Mugu", palikas: [
          { value: "MUGU_CHHAYANATH_RARA_MUN", label: "छायाँनाथ रारा नगरपालिका", englishLabel: "Chhayanath Rara Municipality" },
          { value: "MUGU_MUGUM_KARMARONG_MUN", label: "मुगुम कार्मारोंग गाउँपालिका", englishLabel: "Mugum Karmarong Rural Municipality" },
          { value: "MUGU_SORU_MUN", label: "सोरु गाउँपालिका", englishLabel: "Soru Rural Municipality" },
          { value: "MUGU_KHATYAD_MUN", label: "खत्याड गाउँपालिका", englishLabel: "Khatyad Rural Municipality" }
        ]
      },
      {
        value: "humla", label: "हुम्ला", englishLabel: "Humla", palikas: [
          { value: "HUMLA_SIMKOT_MUN", label: "सिमकोट गाउँपालिका", englishLabel: "Simkot Rural Municipality" },
          { value: "HUMLA_NAMKHA_MUN", label: "नाम्खा गाउँपालिका", englishLabel: "Namkha Rural Municipality" },
          { value: "HUMLA_KHARPUNATH_MUN", label: "खार्पुनाथ गाउँपालिका", englishLabel: "Kharpunath Rural Municipality" },
          { value: "HUMLA_SARKEGAD_MUN", label: "सर्केगाड गाउँपालिका", englishLabel: "Sarkegad Rural Municipality" },
          { value: "HUMLA_CHANKHELI_MUN", label: "चंखेली गाउँपालिका", englishLabel: "Chankheli Rural Municipality" },
          { value: "HUMLA_ADANCHULI_MUN", label: "अदानचुली गाउँपालिका", englishLabel: "Adanchuli Rural Municipality" },
          { value: "HUMLA_TAJAKOT_MUN", label: "ताँजाकोट गाउँपालिका", englishLabel: "Tajakot Rural Municipality" }
        ]
      },
      {
        value: "rukumPaschim", label: "रुकुम पश्चिम", englishLabel: "Rukum West", palikas: [
          { value: "RUKUM_PASCHIM_MUSIKOT_MUN", label: "मुसिकोट नगरपालिका", englishLabel: "Paschim Musikot Municipality" },
          { value: "RUKUM_PASCHIM_CHAURAJHARI_MUN", label: "चौरजहारी नगरपालिका", englishLabel: "Paschim Chaurajhari Municipality" },
          { value: "RUKUM_PASCHIM_AATHBISKOT_MUN", label: "आठबिसकोट नगरपालिका", englishLabel: "Paschim Aathbiskot Municipality" },
          { value: "RUKUM_PASCHIM_BAFIKOT_MUN", label: "बाँफिकोट गाउँपालिका", englishLabel: "Paschim Bafikot Rural Municipality" },
          { value: "RUKUM_PASCHIM_TRIWENI_MUN", label: "त्रिवेणी गाउँपालिका", englishLabel: "Paschim tribeni Rural Municipality" },
          { value: "RUKUM_PASCHIM_SANI_BHERI_MUN", label: "सानी भेरी गाउँपालिका", englishLabel: "Paschim Sani Bheri Rural Municipality" }
        ]
      }]
  },
  {
    value: "SUDURPASHCHIM_PROVINCE", label: "सुदूरपश्चिम प्रदेश", englishLabel: "Sudurpashchim Province", districts: [
      {
        value: "bajura", label: "बाजुरा", englishLabel: "Bajura", palikas: [
          { value: "BAJURA_BADIMALIKA_MUN", label: "बडीमालिका नगरपालिका", englishLabel: "Badimalika Municipality" },
          { value: "BAJURA_TRIWENI_MUN", label: "त्रिवेणी नगरपालिका", englishLabel: "Triweni Municipality" },
          { value: "BAJURA_BUDIGANGA_MUN", label: "बुढीगंगा नगरपालिका", englishLabel: "Budiganga Municipality" },
          { value: "BAJURA_BUDINANDA_MUN", label: "बुढीनन्दा नगरपालिका", englishLabel: "Budinanda Municipality" },
          { value: "BAJURA_GAUMUL_MUN", label: "गौमुल गाउँपालिका", englishLabel: "Gaumul Rural Municipality" },
          { value: "BAJURA_JAGANNATH_MUN", label: "जगन्‍नाथ गाउँपालिका", englishLabel: "Jagannath Rural Municipality" },
          { value: "BAJURA_SWAMIKARTIK_KHAPAR_MUN", label: "स्वामीकार्तिक खापर गाउँपालिका", englishLabel: "Swamikartik Khapar Rural Municipality" },
          { value: "BAJURA_KHAPTAD_CHHEDEDAHA_MUN", label: "खप्तड छेडेदह गाउँपालिका", englishLabel: "Khaptad Chhededaha Rural Municipality" },
          { value: "BAJURA_HIMALI_MUN", label: "हिमाली गाउँपालिका", englishLabel: "Himali Rural Municipality" }
        ]
      },
      {
        value: "bajhang", label: "बझाङ", englishLabel: "Bajhang", palikas: [
          { value: "BAJHANG_JAYAPRITHIWI_MUN", label: "जयपृथ्वी नगरपालिका", englishLabel: "Jayaprithiwi Municipality" },
          { value: "BAJHANG_BUNGAL_MUN", label: "बुंगल नगरपालिका", englishLabel: "Bungal Municipality" },
          { value: "BAJHANG_TALAKOT_MUN", label: "तलकोट गाउँपालिका", englishLabel: "Talakot Rural Municipality" },
          { value: "BAJHANG_MASTA_MUN", label: "मष्टा गाउँपालिका", englishLabel: "Masta Rural Municipality" },
          { value: "BAJHANG_KHAPTADCHHANNA_MUN", label: "खप्तडछान्ना गाउँपालिका", englishLabel: "Khaptadchhanna Rural Municipality" },
          { value: "BAJHANG_THALARA_MUN", label: "थलारा गाउँपालिका", englishLabel: "Thalara Rural Municipality" },
          { value: "BAJHANG_WITTHADCHIR_MUN", label: "वित्थडचिर गाउँपालिका", englishLabel: "Witthadchir Rural Municipality" },
          { value: "BAJHANG_SURMA_MUN", label: "सूर्मा गाउँपालिका", englishLabel: "Surma Rural Municipality" },
          { value: "BAJHANG_CHHABISPATHIBHERA_MUN", label: "छबिसपाथिभेरा गाउँपालिका", englishLabel: "Chhabispathibhera Rural Municipality" },
          { value: "BAJHANG_DURGATHALI_MUN", label: "दुर्गाथली गाउँपालिका", englishLabel: "Durgathali Rural Municipality" },
          { value: "BAJHANG_KEDHARSUE_MUN", label: "केदारस्युँ गाउँपालिका", englishLabel: "Kedharsue Rural Municipality" },
          { value: "BAJHANG_SAIPAL_MUN", label: "साइपाल गाउँपालिका", englishLabel: "Saipal Rural Municipality" }
        ]
      },
      {
        value: "achham", label: "अछाम", englishLabel: "Achham", palikas: [
          { value: "ACHHAM_MANGALSEN_MUN", label: "मंगलसेन नगरपालिका", englishLabel: "Mangalsen Municipality" },
          { value: "ACHHAM_KAMALBAJAR_MUN", label: "कमलबजार नगरपालिका", englishLabel: "Kamalbajar Municipality" },
          { value: "ACHHAM_SAFEBAGAR_MUN", label: "साँफेबगर नगरपालिका", englishLabel: "Safebagar Municipality" },
          { value: "ACHHAM_PANCHADEWAL_WINAYEK_MUN", label: "पन्चदेवल विनायक नगरपालिका", englishLabel: "Panchadewal Winayek Municipality" },
          { value: "ACHHAM_CHAURPATI_MUN", label: "चौरपाटी गाउँपालिका", englishLabel: "Chaurpati Rural Municipality" },
          { value: "ACHHAM_MELLEKH_MUN", label: "मेल्लेख गाउँपालिका", englishLabel: "Mellekh Rural Municipality" },
          { value: "ACHHAM_BANNIGADI_JAYAGAD_MUN", label: "बान्निगढी जयगढ गाउँपालिका", englishLabel: "Bannigadi Jayagad Rural Municipality" },
          { value: "ACHHAM_RAMAROSHAN_MUN", label: "रामारोशन गाउँपालिका", englishLabel: "Ramaroshan Rural Municipality" },
          { value: "ACHHAM_DHAKARI_MUN", label: "ढकारी गाउँपालिका", englishLabel: "Dhakari Rural Municipality" },
          { value: "ACHHAM_TURMAKHAD_MUN", label: "तुर्माखाँद गाउँपालिका", englishLabel: "Turmakhad Rural Municipality" }
        ]
      },
      {
        value: "doti", label: "डोटी", englishLabel: "Doti", palikas: [
          { value: "DOTI_DIPAYEL_SILAGADI_MUN", label: "दिपायल सिलगढी नगरपालिका", englishLabel: "Dipayal Silgadhi Municipality" },
          { value: "DOTI_SHIKHAR_MUN", label: "शिखर नगरपालिका", englishLabel: "Shikhar Municipality" },
          { value: "DOTI_PURBACHAUKI_MUN", label: "पूर्वीचौकी गाउँपालिका", englishLabel: "Purbachauki Rural Municipality" },
          { value: "DOTI_BADIKEDAR_MUN", label: "बडीकेदार गाउँपालिका", englishLabel: "Badikedar Rural Municipality" },
          { value: "DOTI_JORAYAL_MUN", label: "जोरायल गाउँपालिका", englishLabel: "Jorayal Rural Municipality" },
          { value: "DOTI_SAYAL_MUN", label: "सायल गाउँपालिका", englishLabel: "Sayal Rural Municipality" },
          { value: "DOTI_AADARSHA_MUN", label: "आदर्श गाउँपालिका", englishLabel: "Aadarsha Rural Municipality" },
          { value: "DOTI_KIC_MUN", label: "के.आई.सिंह गाउँपालिका", englishLabel: "Kic Rural Municipality" },
          { value: "DOTI_BOGTAN_FUDSIL_MUN", label: "बोगटान फुड्सिल गाउँपालिका", englishLabel: "Bogtan Fudsil Rural Municipality" }
        ]
      },
      {
        value: "kailali", label: "कैलाली", englishLabel: "Kailali", palikas: [
          { value: "KAILALI_DHANGADI_MUN", label: "धनगढी उपमहानगरपालिका", englishLabel: "Dhangadi Sub-Metropolitan City" },
          { value: "KAILALI_TIKAPUR_MUN", label: "टिकापुर नगरपालिका", englishLabel: "Tikapur Municipality" },
          { value: "KAILALI_GHOGHADI_MUN", label: "घोडाघोडी नगरपालिका", englishLabel: "Ghoghadi Municipality" },
          { value: "KAILALI_LAMKICHUHA_MUN", label: "लम्कीचुहा नगरपालिका", englishLabel: "Lamkichuha Municipality" },
          { value: "KAILALI_BHAJANI_MUN", label: "भजनी नगरपालिका", englishLabel: "Bhajani Municipality" },
          { value: "KAILALI_GODAWARI_MUN", label: "गोदावरी नगरपालिका", englishLabel: "Godawari Municipality" },
          { value: "KAILALI_GAURIGANGA_MUN", label: "गौरीगंगा नगरपालिका", englishLabel: "Gauriganga Municipality" },
          { value: "KAILALI_JANAKI_MUN", label: "जानकी गाउँपालिका", englishLabel: "Janaki Rural Municipality" },
          { value: "KAILALI_BARDAGORIYA_MUN", label: "बर्दगोरिया गाउँपालिका", englishLabel: "Bardagoriya Rural Municipality" },
          { value: "KAILALI_MOHANYAL_MUN", label: "मोहन्याल गाउँपालिका", englishLabel: "Mohanyal Rural Municipality" },
          { value: "KAILALI_KAILARI_MUN", label: "कैलारी गाउँपालिका", englishLabel: "Kailari Rural Municipality" },
          { value: "KAILALI_JOSHIPUR_MUN", label: "जोशीपुर गाउँपालिका", englishLabel: "Joshipur Rural Municipality" },
          { value: "KAILALI_CHURE_MUN", label: "चुरे गाउँपालिका", englishLabel: "Chure Rural Municipality" }
        ]
      },
      {
        value: "kanchanpur", label: "कञ्चनपुर", englishLabel: "Kanchanpur", palikas: [
          { value: "KANCHANPUR_BHEEMDATTA_MUN", label: "भीमदत्त नगरपालिका", englishLabel: "Bheemdatta Municipality" },
          { value: "KANCHANPUR_PUNARBAAS_MUN", label: "पुर्नवास नगरपालिका", englishLabel: "Punarbaas Municipality" },
          { value: "KANCHANPUR_WEDAKOT_MUN", label: "वेदकोट नगरपालिका", englishLabel: "Wedakot Municipality" },
          { value: "KANCHANPUR_MAHAKALI_MUN", label: "दोधारा चादँनी नगरपालिका", englishLabel: "Mahakali Municipality" },
          { value: "KANCHANPUR_SUKLAFATA_MUN", label: "शुक्लाफाँटा नगरपालिका", englishLabel: "Suklafata Municipality" },
          { value: "KANCHANPUR_BELAURI_MUN", label: "बेलौरी नगरपालिका", englishLabel: "Belauri Municipality" },
          { value: "KANCHANPUR_KRISHNAPUR_MUN", label: "कृष्णपुर नगरपालिका", englishLabel: "Krishnapur Municipality" },
          { value: "KANCHANPUR_BELDADI_MUN", label: "बेलडाडी गाउँपालिका", englishLabel: "Beldadi Rural Municipality" },
          { value: "KANCHANPUR_LALJHADI_MUN", label: "लालझाडी गाउँपालिका", englishLabel: "Laljhadi Rural Municipality" }
        ]
      },
      {
        value: "dadeldhura", label: "डडेल्धुरा", englishLabel: "Dadeldhura", palikas: [
          { value: "DADELDHURA_AMARGADI_MUN", label: "अमरगढी नगरपालिका", englishLabel: "Amargadi Municipality" },
          { value: "DADELDHURA_PARASHURAM_MUN", label: "परशुराम नगरपालिका", englishLabel: "Parashuram Municipality" },
          { value: "DADELDHURA_AALITAL_MUN", label: "आलिताल गाउँपालिका", englishLabel: "Aalital Rural Municipality" },
          { value: "DADELDHURA_BHAGESHOWER_MUN", label: "भागेश्वर गाउँपालिका", englishLabel: "Bhageshower Rural Municipality" },
          { value: "DADELDHURA_NAWADURGA_MUN", label: "नवदुर्गा गाउँपालिका", englishLabel: "Nawadurga Rural Municipality" },
          { value: "DADELDHURA_AJAYMERU_MUN", label: "अजयमेरु गाउँपालिका", englishLabel: "Ajaymeru Rural Municipality" },
          { value: "DADELDHURA_GANNYAPADHURA_MUN", label: "गन्यापधुरा गाउँपालिका", englishLabel: "Gannyapadhura Rural Municipality" }
        ]
      },
      {
        value: "baitadi", label: "बैतडी", englishLabel: "Baitadi", palikas: [
          { value: "BAITADI_DASHARATHACHANDA_MUN", label: "दशरथचन्द नगरपालिका", englishLabel: "Dasharathachanda Municipality" },
          { value: "BAITADI_PATAN_MUN", label: "पाटन नगरपालिका", englishLabel: "Patan Municipality" },
          { value: "BAITADI_MELAULI_MUN", label: "मेलौली नगरपालिका", englishLabel: "Melauli Municipality" },
          { value: "BAITADI_PUCHAURDI_MUN", label: "पुर्चौडी नगरपालिका", englishLabel: "Puchaurdi Municipality" },
          { value: "BAITADI_SURNAYA_MUN", label: "सुर्नया गाउँपालिका", englishLabel: "Surnaya Rural Municipality" },
          { value: "BAITADI_SIGASA_MUN", label: "सिगास गाउँपालिका", englishLabel: "Sigasa Rural Municipality" },
          { value: "BAITADI_SHIWANATH_MUN", label: "शिवनाथ गाउँपालिका", englishLabel: "Shiwanath Rural Municipality" },
          { value: "BAITADI_PANCHESHOWER_MUN", label: "पञ्चेश्वर गाउँपालिका", englishLabel: "Pancheshower Rural Municipality" },
          { value: "BAITADI_DOGADAKEDAR_MUN", label: "दोगडाकेदार गाउँपालिका", englishLabel: "Dogadakedar Rural Municipality" },
          { value: "BAITADI_DILASAINI_MUN", label: "डीलासैनी गाउँपालिका", englishLabel: "Dilasaini Rural Municipality" }
        ]
      },
      {
        value: "darchula", label: "दार्चुला", englishLabel: "Darchula", palikas: [
          { value: "DARCHULA_MAHAKALI_MUN", label: "महाकाली नगरपालिका", englishLabel: "Mahakali Municipality" },
          { value: "DARCHULA_SHAILYASHIKHAR_MUN", label: "शैल्यशिखर नगरपालिका", englishLabel: "Shailyashikhar Municipality" },
          { value: "DARCHULA_MALIKARJUN_MUN", label: "मालिकार्जुन गाउँपालिका", englishLabel: "Malikarjun Rural Municipality" },
          { value: "DARCHULA_APIHIMAL_MUN", label: "अपिहिमाल गाउँपालिका", englishLabel: "Apihimal Rural Municipality" },
          { value: "DARCHULA_DUHU_MUN", label: "दुहुँ गाउँपालिका", englishLabel: "Duhu Rural Municipality" },
          { value: "DARCHULA_NAUGAD_MUN", label: "नौगाड गाउँपालिका", englishLabel: "Naugad Rural Municipality" },
          { value: "DARCHULA_MARMA_MUN", label: "मार्मा गाउँपालिका", englishLabel: "Marma Rural Municipality" },
          { value: "DARCHULA_LEKAM_MUN", label: "लेकम गाउँपालिका", englishLabel: "Lekam Rural Municipality" },
          { value: "DARCHULA_BYAS_MUN", label: "ब्याँस गाउँपालिका", englishLabel: "Byas Rural Municipality" }
        ]
      }
    ]
  }
];